import { AWS_HTTP } from './http-common.js'
import { log } from './http-common.js'
import axios from 'axios'
const dateFormat = require('dateformat')
import store from './store.js'
import router from './router'
import states from './data/state-crosswalk.js'
import { v4 as uuidv4 } from 'uuid'

export default {
  errors: [],
  passesAgeReqs(person, test) {
    let exclude = false

    if (test.minAgeYears) {
      if (person.age < test.minAgeYears) {
        exclude = true
      }
    }

    if (test.maxAgeYears) {
      if (person.age > test.maxAgeYears) {
        exclude = true
      }
    }

    if (test.minAgeDays) {
      if (person.ageInDays && person.ageInDays < test.minAgeDays) {
        exclude = true
      }
    }

    if (test.maxAgeDays) {
      if (person.ageInDays && person.ageInDays > test.maxAgeDays) {
        exclude = true
      }
    }

    return !exclude
  },
  getSignatureRequired(personAndProduct, guaranteeIssueRules) {
    if (personAndProduct && guaranteeIssueRules && personAndProduct.rate) {
      this.guaranteeIssue = []
      for (let idx = 0; idx < guaranteeIssueRules.length; idx++) {
        this.guaranteeIssue.push(guaranteeIssueRules[idx])
      }
      return this.meetsAgeAndGuaranteeIssueReqs(personAndProduct)
    } else return false
  },
  meetsAgeAndGuaranteeIssueReqs(personAndProduct) {
    let evalObj = personAndProduct

    let applicableGIs = this.guaranteeIssue.filter(
      f => f.planCode === evalObj.product.planCodeId
    )

    if (applicableGIs && applicableGIs.length > 0) {
      for (let a = 0; a < applicableGIs.length; a++) {
        let applicableGI = applicableGIs[a]
        let person = personAndProduct.person

        // Process Employee

        if (person.type === 'employee' || person.type === 'applicant') {
          // Check Sign Condition
          if (applicableGI.sign.employee === 'always') {
            return true
          }

          if (applicableGI.sign.employee === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueEmployee.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueEmployee[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueEmployee[idx]
                  .overDollarFaceAmt != undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueEmployee[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueEmployee[idx]
                  .overDollarPremium != undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueEmployee[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        } else if (person.type === 'spouse') {
          // Check Sign Condition
          if (applicableGI.sign.spouse === 'always') return true

          if (applicableGI.sign.spouse === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueSpouse.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueSpouse[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueSpouse[idx].overDollarFaceAmt !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueSpouse[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueSpouse[idx].overDollarPremium !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueSpouse[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        } else if (person.type === 'child') {
          // Check Sign Condition
          if (applicableGI.sign.child === 'always') return true

          if (applicableGI.sign.child === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueChild.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueChild[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueChild[idx].sign != undefined &&
                applicableGI.overGuaranteeIssueChild[idx].sign == false
              ) {
                return false
              }

              if (
                applicableGI.overGuaranteeIssueChild[idx].overDollarFaceAmt !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueChild[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueChild[idx].overDollarPremium !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueChild[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        }

        return false
      }
    }
  },
  meetsAgeAndGuaranteeIssueReqsIncludeChildren(personAndProduct) {
    let evalObj = personAndProduct

    let applicableGIs = this.guaranteeIssue.filter(
      f => f.planCode === evalObj.product.planCodeId
    )
    if (applicableGIs && applicableGIs.length > 0) {
      for (let a = 0; a < applicableGIs.length; a++) {
        let applicableGI = applicableGIs[a]
        let person = personAndProduct.person

        // Process Employee

        if (person.type === 'employee' || person.type === 'applicant') {
          // Check Sign Condition
          if (applicableGI.sign.employee === 'always') {
            return true
          }

          if (applicableGI.sign.employee === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueEmployee.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueEmployee[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueEmployee[idx]
                  .overDollarFaceAmt != undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueEmployee[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueEmployee[idx]
                  .overDollarPremium != undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueEmployee[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        } else if (person.type === 'spouse') {
          // Check Sign Condition
          if (applicableGI.sign.spouse === 'always') return true

          if (applicableGI.sign.spouse === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueSpouse.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueSpouse[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueSpouse[idx].overDollarFaceAmt !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueSpouse[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueSpouse[idx].overDollarPremium !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueSpouse[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        } else if (person.type === 'child') {
          // Check Sign Condition
          if (applicableGI.sign.child === 'always') return true

          if (applicableGI.sign.child === 'na') return false

          // Check Age/Dollar Conditions
          for (
            let idx = 0;
            idx < applicableGI.overGuaranteeIssueChild.length;
            idx++
          ) {
            if (
              this.passesAgeReqs(
                person,
                applicableGI.overGuaranteeIssueChild[idx]
              )
            ) {
              if (
                applicableGI.overGuaranteeIssueChild[idx].overDollarFaceAmt !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.faceAmt) >
                  applicableGI.overGuaranteeIssueChild[idx].overDollarFaceAmt
              ) {
                return true
              } else if (
                applicableGI.overGuaranteeIssueChild[idx].overDollarPremium !=
                  undefined &&
                evalObj.rate != undefined &&
                parseFloat(evalObj.rate.premium) >
                  applicableGI.overGuaranteeIssueChild[idx].overDollarPremium
              ) {
                return true
              }
            }
          }
        }

        return false
      }
    }
  },
  findSelectionInfo(selection) {
    let details = selection.split('|')
    let productId = -1
    let planCodeId = -1
    let personId = -1
    let riderId = -1

    if (details.length >= 3) {
      productId = details[0]
      planCodeId = details[1]
      personId = details[2]
    }

    if (details.length >= 4) {
      riderId = details[3]
    }

    let storedPersons = store.getters.applicableIndividuals
    let eligibleProducts = store.state.eligibleProducts
    let riders = store.state.riders

    if (riderId > -1) {
      for (let idx = 0; idx < storedPersons.length; idx++) {
        for (let j = 0; j < eligibleProducts.length; j++) {
          for (let rider of riders) {
            if (
              productId == eligibleProducts[j].productId &&
              personId == storedPersons[idx].id &&
              riderId == rider.id
            ) {
              let personAndProduct = {
                person: storedPersons[idx],
                product: {
                  name: rider.name,
                  id: -1,
                  excludesProducts: []
                },
                rider: rider
              }

              return personAndProduct
            }
          }
        }
      }
    }

    for (let idx = 0; idx < storedPersons.length; idx++) {
      for (let j = 0; j < eligibleProducts.length; j++) {
        if (
          productId == eligibleProducts[j].productId &&
          planCodeId == eligibleProducts[j].planCodeId &&
          personId == storedPersons[idx].id
        ) {
          let personAndProduct = {
            person: storedPersons[idx],
            product: eligibleProducts[j],
            rider: undefined
          }

          // if (personAndProduct.product.name.indexOf('Cancer') >= 0) {
          //   personAndProduct.product.planNumber = store.state.cancerPlan
          // }

          let riderIdx = store.state.riders.findIndex(r => r.id === riderId)
          if (riderIdx && riderIdx > 0) {
            personAndProduct.rider = this.riders[riderIdx]
          }

          return personAndProduct
        }
      }
    }

    return undefined
  },
  collectPromises() {
    let promises = []

    promises.push(
      AWS_HTTP.get('templates', {
        params: {}
      }).then(response => {
        let body = JSON.parse(response.data.body)

        this.definitions = body.template_definitions
        this.prefilled = body.template_prefilled
        this.fields = body.template_fields ? body.template_fields : []
        this.roleMappings = body.template_role_mappings
        this.roles = body.template_roles
        this.texts = body.template_texts
        this.checks = body.template_checks
        this.rules = body.template_rules
        this.repeatTypes = body.template_repeat_types
        this.planTemplates = body.plan_templates
        this.requiredTemplates = body.required_templates
        this.leaveBehinds = body.leave_behinds
      })
    )

    promises.push(
      AWS_HTTP.get('guarantee-issue', {
        params: {}
      })
        .then(response => {
          let body = JSON.parse(response.data.body)

          this.guaranteeIssue = body
        })
        .catch(e => {
          log(e.toString(), true, 'logic.js collectPromises')
          this.errors.push(e)
        })
    )

    return promises
  },
  retryCallAPIAndRedirect(body, callback) {
    AWS_HTTP.post('envelopes', body, {
      // headers: {
      //   'Access-Control-Allow-Origin': '*',
      //   'Access-Control-Allow-Headers':
      //     'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
      //   'Access-Control-Allow-Credentials': true,
      //   'Content-Type': 'application/json'
      // }
    })
      .then(response => {
        if (response.data && response.data.indexOf('undefined') < 0) {
          let URLs = response.data

          let redirectIdx = URLs.findIndex(u => u.signOrder === 1)

          if (redirectIdx >= 0) {
            store.commit('updateExternalRoute', URLs[redirectIdx].URL)
            router.replace('toSigningApplication')
          }

          callback(null, 'success!')
        } else {
          callback('ERROR!')
        }
      })

      .catch(e => {
        log(e.toString(), true, 'logic.js retryCallAPIAndRedirect')
        callback('ERROR!')
      })
  },
  callAPIAndRedirect() {
    this.errors = []

    let promises = this.collectPromises()

    axios.all(promises).then(() => {
      let body = {}

      try {
        body = this.buildBody()
      } catch (e) {
        log(e.toString(), true, 'logic.js callAPIAndRedirect')
        this.errors.push(e)
      }
      if (this.errors.length != 0) {
        store.commit('setShowErrorDialog', true)
        return
      }

      // console.log(body)

      let doNotSend = false

      if (!doNotSend) {
        body.uuid = uuidv4()
        body.uuid += '-' + Date.now().toString()

        // console.log(body.uuid);

        AWS_HTTP.post('envelopes', body, {
          // headers: {
          //   'Access-Control-Allow-Origin': '*',
          //   'Access-Control-Allow-Headers':
          //     'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
          //   'Access-Control-Allow-Credentials': true,
          //   'Content-Type': 'application/json'
          // }
        })
          .then(response => {
            if (response.data) {
              let URLs = response.data

              let redirectIdx = URLs.findIndex(u => u.signOrder === 1)

              if (
                redirectIdx >= 0 &&
                URLs[redirectIdx].URL.indexOf('undefined') < 0
              ) {
                store.commit('updateExternalRoute', URLs[redirectIdx].URL)
                router.replace('toSigningApplication')
              } else {
                store.commit('setShowErrorDialog', true)
              }
            } else {
              store.commit('setShowErrorDialog', true)
            }
          })

          .catch(e => {
            log(e.toString(), true, 'logic.js callAPIAndRedirect')

            let retryCount = 0

            let timerId = setInterval(() => {
              retryCount++

              AWS_HTTP.get('url', { params: { uuid: body.uuid } })
                .then(response => {
                  // console.log(response);

                  let url = response.data.url

                  if (url != '') {
                    clearInterval(timerId)
                    store.commit('updateExternalRoute', url)
                    router.replace('toSigningApplication')
                  } else if (retryCount == 10) {
                    clearInterval(timerId)
                    store.commit('setShowErrorDialog', true)
                  }
                })
                .catch(e => {
                  log(e.toString(), true, 'logic.js callAPIAndRedirect')
                  store.commit('setShowErrorDialog', true)
                  clearInterval(timerId)
                })
            }, 5000)

            // Try one more time, then stop.
            // this.retryCallAPIAndRedirect(body, function(err, result) {
            //   if (err) {
            //     store.commit('setShowErrorDialog', true)
            //   } else if (result) {
            //     // console.log('redirecting...')
            //   }
            // })
          })
      }
    })
  },
  checkForADB(personType, person, plan) {
    for (let s = 0; s < store.state.selections.length; s++) {
      if (store.state.selections[s]) {
        let si = this.findSelectionInfo(store.state.selections[s])

        if (si.person.id === person.id) {
          if (si.rider != undefined) {
            if (si.rider.type && si.rider.type.toUpperCase() === 'ADB') {
              if (
                si.rider.planCodes &&
                si.rider.planCodes.findIndex(
                  p => p === plan.product.planCodeId
                ) >= 0
              ) {
                let retString = 'Yes'

                let applicableRates = store.state.rates.filter(
                  r => r.personId === person.id
                )

                for (let rate of applicableRates) {
                  if (
                    rate.rider &&
                    rate.rider.coverages &&
                    rate.rider.type.toUpperCase() === 'ADB'
                  ) {
                    let index = rate.rider.planCodes.findIndex(
                      p => p === plan.product.planCodeId
                    )
                    if (index != undefined && index >= 0) {
                      let c = rate.rider.coverages.findIndex(
                        cov =>
                          parseFloat(cov.PremiumPerWeek) ==
                          parseFloat(rate.premium)
                      )

                      if (c != undefined && c >= 0) {
                        retString += ' - ' + rate.rider.coverages[c].units
                        break
                      }
                    }
                  }
                }

                return retString
              }
            }
          }
        }
      }
    }

    if (plan.product.planNumber === '') return ''

    return 'No'
  },
  checkForChildRider(personType, person, plan) {
    for (let s = 0; s < store.state.selections.length; s++) {
      if (store.state.selections[s]) {
        let si = this.findSelectionInfo(store.state.selections[s])

        if (si.person.id === person.id) {
          if (si.rider != undefined) {
            if (si.rider.type && si.rider.type.toUpperCase() === 'CR') {
              if (
                si.rider.planCodes &&
                si.rider.planCodes.findIndex(
                  p => p === plan.product.planCodeId
                ) >= 0
              ) {
                return ' CR'
              }
            }
          }
        }
      }
    }
    return ''
  },
  checkForTerminalIllnessTemplateId(person, product) {
    for (let s = 0; s < store.state.selections.length; s++) {
      if (store.state.selections[s]) {
        let si = this.findSelectionInfo(store.state.selections[s])

        if (si.person.id === person.id) {
          if (si.rider != undefined) {
            if (si.rider.type && si.rider.type.toUpperCase() === 'TI') {
              if (
                si.rider.planCodes &&
                si.rider.planCodes.findIndex(p => p === product.planCodeId) >= 0
              ) {
                return si.rider.templateId
              }
            }
          }
        }
      }
    }
    return -1
  },
  checkForDepositFundTemplateId(person, product) {
    for (let s = 0; s < store.state.selections.length; s++) {
      if (store.state.selections[s]) {
        let si = this.findSelectionInfo(store.state.selections[s])

        if (si.person.id === person.id) {
          if (si.rider != undefined) {
            if (si.rider.type && si.rider.type.toUpperCase() === 'DFR') {
              if (
                si.rider.planCodes &&
                si.rider.planCodes.findIndex(p => p === product.planCodeId) >= 0
              ) {
                return si.rider.templateId
              }
            }
          }
        }
      }
    }
    return -1
  },
  getField(
    fieldName,
    applicants,
    childNum,
    planNum,
    copyNum,
    maxChildrenPerPage,
    maxPlansPerPage,
    maxChildSignaturesPerPage,
    pages,
    formatRule,
    cancerApplicant
  ) {
    if (fieldName == 'employeeId') {
      return store.state.employee.EmployeeId
    }

    if (cancerApplicant) {
      if (fieldName == 'cancerPlan') {
        return cancerApplicant.planCodeId
      }

      if (fieldName == 'cancerBenefit') {
        return cancerApplicant.rate.faceAmt
      }

      if (fieldName == 'cancerBenefitThousands') {
        if (cancerApplicant.rate.faceAmt.length > 3) {
          return cancerApplicant.rate.faceAmt.substr(
            0,
            cancerApplicant.rate.faceAmt.length - 3
          )
        } else {
          return ''
        }
      }

      if (fieldName == 'cancerBenefitHundreds') {
        if (cancerApplicant.rate.faceAmt.length > 3) {
          return cancerApplicant.rate.faceAmt.substr(
            cancerApplicant.rate.faceAmt.length - 3,
            3
          )
        } else {
          let hundreds = cancerApplicant.rate.faceAmt
          if (hundreds.length < 3)
            return '   '.substr(0, 3 - hundreds.length) + hundreds
          else return hundreds
        }
      }

      if (fieldName == 'cancerWeekly') {
        return cancerApplicant.rate.premium
      }

      if (fieldName == 'cancerWeeklyDollars') {
        let dollars = cancerApplicant.rate.premium.split('.')[0]

        if (dollars.length < 3) {
          return '   '.substr(0, 3 - dollars.length) + dollars
        } else return dollars
      }

      if (fieldName == 'cancerWeeklyCents') {
        if (cancerApplicant.rate.premium.indexOf('.') >= 0) {
          let cents = cancerApplicant.rate.premium.split('.')[1]

          if (cents.length == 2) return cents
          else return cents + '0'
        } else return '00'
      }
    }

    if (fieldName === 'totalWeeklyPremium') {
      return store.state.totalWeeklyPremium
    }

    if (fieldName === 'biweeklyLifePremAmtThousands') {
      let amt = (parseFloat(store.state.totalLifePremium) * 2).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        return dollars.substr(0, dollars.length - 3)
      } else {
        return ''
      }
    }

    if (fieldName === 'biweeklyLifePremAmtHundreds') {
      let amt = (parseFloat(store.state.totalLifePremium) * 2).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        return dollars.substr(dollars.length - 3, 3)
      } else {
        let hundreds = dollars
        if (hundreds.length < 3)
          return '   '.substr(0, 3 - hundreds.length) + hundreds
        else return hundreds
      }
    }

    if (fieldName === 'biweeklyLifePremAmtCents') {
      let amt = (parseFloat(store.state.totalLifePremium) * 2).toString()

      if (amt.indexOf('.') >= 0) {
        let cents = amt.split('.')[1]

        if (cents.length == 2) return cents
        else return cents + '0'
      } else return '00'
    }

    if (fieldName === 'biweeklyDFRPremAmtThousands') {
      let amt = (parseFloat(store.state.totalDFRPremium) * 2).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        return dollars.substr(0, dollars.length - 3)
      } else {
        return ''
      }
    }

    if (fieldName === 'biweeklyDFRPremAmtHundreds') {
      let amt = (parseFloat(store.state.totalDFRPremium) * 2).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        return dollars.substr(dollars.length - 3, 3)
      } else {
        let hundreds = dollars
        if (hundreds.length < 3)
          return '   '.substr(0, 3 - hundreds.length) + hundreds
        else return hundreds
      }
    }

    if (fieldName === 'biweeklyDFRPremAmtCents') {
      let amt = (parseFloat(store.state.totalDFRPremium) * 2).toString()

      if (amt.indexOf('.') >= 0) {
        let cents = amt.split('.')[1]

        if (cents.length == 2) return cents
        else return cents + '0'
      } else return '00'
    }

    if (fieldName === 'biweeklyDFRDraftAmtThousands') {
      let amt = (
        parseFloat(store.state.totalLifePremium) * 2 +
        parseFloat(store.state.totalDFRPremium) * 2
      ).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        let thousands = dollars.substr(0, dollars.length - 3)

        if (thousands.length < 2) {
          return '   '.substr(0, 2 - thousands.length) + thousands
        } else {
          return thousands
        }
      } else {
        return ''
      }
    }

    if (fieldName === 'biweeklyDFRDraftAmtHundreds') {
      let amt = (
        parseFloat(store.state.totalLifePremium) * 2 +
        parseFloat(store.state.totalDFRPremium) * 2
      ).toString()

      let dollars = amt.split('.')[0]

      if (dollars.length > 3) {
        return dollars.substr(dollars.length - 3, 3)
      } else {
        let hundreds = dollars
        if (hundreds.length < 3)
          return '   '.substr(0, 3 - hundreds.length) + hundreds
        else return hundreds
      }
    }

    if (fieldName === 'biweeklyDFRDraftAmtCents') {
      let amt = (
        parseFloat(store.state.totalLifePremium) * 2 +
        parseFloat(store.state.totalDFRPremium) * 2
      ).toString()

      if (amt.indexOf('.') >= 0) {
        let cents = amt.split('.')[1]

        if (cents.length == 2) return cents
        else return cents + '0'
      } else return '00'
    }

    if (fieldName === 'paycheckDeductions') {
      let amt = ''
      let value = store.state.paycheckDeductions

      if (Math.floor(parseFloat(value)) === parseFloat(value))
        amt = value.toString().split('.')[0]
      else amt = parseFloat(value).toFixed(2)

      var parts = amt.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')

      //return store.state.paycheckDeductions
    }

    if (fieldName === 'paycheckFrequency') {
      return store.state.payPeriodsRadio
    }

    if (fieldName === 'paycheckFrequencyOther') {
      return store.state.payPeriodsOther
    }

    if (fieldName === 'todaysDate') {
      let today = dateFormat(new Date(), 'mm/dd/yyyy')
      return today
    }

    if (
      childNum &&
      childNum > 0 &&
      pages &&
      pages.length > 0 &&
      copyNum <= pages.length
    ) {
      // used for applicant repeats - multiple children

      // find the correct child:

      let applicant = undefined

      let idx = -1

      if (childNum - 1 < pages[copyNum - 1].length) {
        idx = applicants.findIndex(
          a =>
            pages[copyNum - 1] &&
            pages[copyNum - 1][childNum - 1] &&
            a.person.id === pages[copyNum - 1][childNum - 1].applicant
        )
      }

      if (idx >= 0) applicant = applicants[idx]

      if (applicant === undefined) return ''

      if (applicant) {
        switch (fieldName) {
          case 'childName': {
            if (formatRule === 'reverseName') {
              return (
                applicant.person.lastName +
                ',' +
                applicant.person.firstName +
                ' ' +
                applicant.person.middleName
              ).trim()
            } else {
              return applicant.person.name
            }
          }
          case 'childFirstName':
            return applicant.person.firstName
          case 'childMiddleName':
            return applicant.person.middleName
          case 'childMI':
            return applicant.person.middleName.length
              ? applicant.person.middleName.substr(0, 1)
              : ''
          case 'childLastName':
            return applicant.person.lastName
          case 'childDOB':
            return applicant.person.birthdate
          case 'childEmail':
            return applicant.person.email
          case 'childSex':
            return applicant.person.sex
          case 'childAge': {
            if (applicant.person.age) return applicant.person.age.toString()
            else if (applicant.person.ageInDays) return '0'
          }
        }

        if (planNum && planNum > 0) {
          // used for multiple plans, amounts, etc for the same child

          let plan = pages[copyNum - 1][childNum - 1].plan

          if (plan === undefined) return ''
          else {
            switch (fieldName) {
              case 'childADB':
                return this.checkForADB('child', applicant.person, plan)
              case 'childPlan':
                return (
                  plan.product.planNumber +
                  this.checkForChildRider('child', applicant.person, plan)
                )
              case 'childFaceAmt':
                return plan.rate.faceAmt
              case 'childWeeklyPremium':
                return plan.rate.premium
            }
          }
        }
      }
    } else if (childNum && childNum > 0) {
      let applicant = undefined

      let kids = applicants.filter(a => a.person.type == 'child')
      if (kids && kids.length >= childNum) applicant = kids[childNum - 1]

      if (applicant === undefined) return ''

      if (applicant) {
        switch (fieldName) {
          case 'childName': {
            if (formatRule === 'reverseName') {
              return (
                applicant.person.lastName +
                ',' +
                applicant.person.firstName +
                ' ' +
                applicant.person.middleName
              ).trim()
            } else {
              return applicant.person.name
            }
          }
          case 'childFirstName':
            return applicant.person.firstName
          case 'childMiddleName':
            return applicant.person.middleName
          case 'childMI':
            return applicant.person.middleName.length
              ? applicant.person.middleName.substr(0, 1)
              : ''
          case 'childLastName':
            return applicant.person.lastName
          case 'childDOB':
            return applicant.person.birthdate
          case 'childEmail':
            return applicant.person.email
          case 'childSex':
            return applicant.person.sex
          case 'childAge': {
            if (applicant.person.age) return applicant.person.age.toString()
            else if (applicant.person.ageInDays) return '0'
          }
        }

        //   if (planNum && planNum > 0) {
        //     // used for multiple plans, amounts, etc for the same child

        //     let plan = pages[copyNum - 1][childNum - 1].plan

        //     if (plan === undefined) return ''
        //     else {
        //       switch (fieldName) {
        //         case 'childADB':
        //           return this.checkForADB('child', applicant.person, plan)
        //         case 'childPlan':
        //           return (
        //             plan.product.planNumber +
        //             this.checkForChildRider('child', applicant.person, plan)
        //           )
        //         case 'childFaceAmt':
        //           return plan.rate.faceAmt
        //         case 'childWeeklyPremium':
        //           return plan.rate.premium
        //       }
        //     }
        //   }
      }
    } else if (planNum && planNum > 0) {
      // used for field repeats - multiple plans for one person, etc.

      if (copyNum > 1) {
        let advanceBy = maxPlansPerPage * (copyNum - 1)
        planNum += advanceBy
      }

      if (
        fieldName.toLowerCase().indexOf('spouse') >= 0 &&
        fieldName.toLowerCase().indexOf('bene') < 0
      ) {
        let spouse = applicants.find(
          a => a.person.type.toLowerCase() === 'spouse'
        )

        if (!spouse) return ''

        let applicant = spouse

        let planCount = 0

        if (planNum > applicant.plans.length) return ''
        let plan = undefined

        for (let p = 0; p < applicant.plans.length; p++) {
          planCount++

          if (planCount === planNum) {
            plan = applicant.plans[p]
          }
        }

        if (plan === undefined) return ''
        else {
          switch (fieldName) {
            case 'spouseADB':
              return this.checkForADB('spouse', applicant.person, plan)
            case 'spousePlan':
              return (
                plan.product.planNumber +
                this.checkForChildRider('spouse', applicant.person, plan)
              )
            case 'spouseFaceAmt':
              return plan.rate.faceAmt
            case 'spouseWeeklyPremium':
              return plan.rate.premium
            case 'spouseName':
              if (formatRule === 'reverseName') {
                return (
                  applicant.person.lastName +
                  ',' +
                  applicant.person.firstName +
                  ' ' +
                  applicant.person.middleName
                ).trim()
              } else {
                return applicant.person.name
              }
            case 'spouseFirstName':
              return applicant.person.firstName
            case 'spouseMiddleName':
              return applicant.person.middleName
            case 'spouseMI':
              return applicant.person.middleName.length
                ? applicant.person.middleName.substr(0, 1)
                : ''
            case 'spouseLastName':
              return applicant.person.lastName

            case 'spouseDOB':
              return applicant.person.birthdate
            case 'spouseEmail':
              return applicant.person.email
            case 'spouseSex':
              return applicant.person.sex
            case 'spouseAge':
              return applicant.person.age
          }
        }
      } else {
        let employee = applicants.find(
          a => a.person.type.toLowerCase() === 'employee'
        )

        if (!employee) return ''

        let applicant = employee

        let value = applicant.person.homePhone

        value = value.replace(/-/g, '')
        value = value.replace(/\./g, '')
        value = value.replace(/\(/g, '')
        value = value.replace(/\)/g, '')
        value = value.replace(/ /g, '')

        applicant.person.homePhoneForParsing = value

        value = applicant.person.workPhone

        value = value.replace(/-/g, '')
        value = value.replace(/\./g, '')
        value = value.replace(/\(/g, '')
        value = value.replace(/\)/g, '')
        value = value.replace(/ /g, '')

        applicant.person.workPhoneForParsing = value

        let planCount = 0

        if (planNum > applicant.plans.length) return ''

        let plan = undefined

        for (let p = 0; p < applicant.plans.length; p++) {
          planCount++

          if (planCount === planNum) {
            plan = applicant.plans[p]
          }
        }

        if (plan === undefined) return ''
        else {
          switch (fieldName) {
            case 'employeeADB':
              return this.checkForADB('employee', applicant.person, plan)
            case 'employeePlan':
              return (
                plan.product.planNumber +
                this.checkForChildRider('employee', applicant.person, plan)
              )
            case 'employeeFaceAmt':
              return plan.rate.faceAmt
            case 'employeeWeeklyPremium':
              return plan.rate.premium
            case 'employeeName':
              if (formatRule === 'reverseName') {
                return (
                  applicant.person.lastName +
                  ',' +
                  applicant.person.firstName +
                  ' ' +
                  applicant.person.middleName
                ).trim()
              } else {
                return applicant.person.name
              }
            case 'employeeFirstName':
              return applicant.person.firstName
            case 'employeeMiddleName':
              return applicant.person.middleName
            case 'employeeMI':
              return applicant.person.middleName.length
                ? applicant.person.middleName.substr(0, 1)
                : ''
            case 'employeeLastName':
              return applicant.person.lastName
            case 'employeeAddr':
              return applicant.person.street
            case 'employeeCity':
              return applicant.person.city
            case 'employeeState':
              return applicant.person.state
            case 'employeeZip':
              return applicant.person.zip
            case 'employeeZipFirst5':
              return applicant.person.zip.substr(0, 5)
            case 'employeeZipLast4': {
              if (applicant.person.zip.length == 9) {
                return applicant.person.zip.substr(5, 4)
              }

              return ''
            }
            case 'employeePhone':
              return applicant.person.homePhone
            case 'employeePhoneArea': {
              if (applicant.person.homePhoneForParsing.length == 11) {
                return applicant.person.homePhoneForParsing.substr(1, 3)
              } else {
                return applicant.person.homePhoneForParsing.substr(0, 3)
              }
            }
            case 'employeePhoneFirstThree': {
              if (applicant.person.homePhoneForParsing.length == 11) {
                return applicant.person.homePhoneForParsing.substr(4, 3)
              } else {
                return applicant.person.homePhoneForParsing.substr(3, 3)
              }
            }
            case 'employeePhoneLastFour': {
              if (applicant.person.homePhoneForParsing.length == 11) {
                return applicant.person.homePhoneForParsing.substr(7, 4)
              } else {
                return applicant.person.homePhoneForParsing.substr(6, 4)
              }
            }
            case 'employeeWorkPhone':
              return applicant.person.workPhone

            case 'employeeWorkPhoneArea': {
              if (applicant.person.workPhoneForParsing.length < 10) return ''
              else if (applicant.person.workPhoneForParsing.length == 11) {
                return applicant.person.workPhoneForParsing.substr(1, 3)
              } else {
                return applicant.person.workPhoneForParsing.substr(0, 3)
              }
            }
            case 'employeeWorkPhoneFirstThree': {
              if (applicant.person.workPhoneForParsing.length < 10) return ''
              else if (applicant.person.workPhoneForParsing.length == 11) {
                return applicant.person.workPhoneForParsing.substr(4, 3)
              } else {
                return applicant.person.workPhoneForParsing.substr(3, 3)
              }
            }
            case 'employeeWorkPhoneLastFour': {
              if (applicant.person.workPhoneForParsing.length < 10) return ''
              else if (applicant.person.workPhoneForParsing.length == 11) {
                return applicant.person.workPhoneForParsing.substr(7, 4)
              } else {
                return applicant.person.workPhoneForParsing.substr(6, 4)
              }
            }

            case 'employeeEmail':
              return applicant.person.email
            case 'employeeSex':
              return applicant.person.sex
            case 'employeeAge':
              return applicant.person.age
            case 'employeeDOB':
              return applicant.person.birthdate
          }
        }
      }
    }

    switch (fieldName) {
      case 'entity':
        return store.state.lpb &&
          store.state.lpb.lpb_name &&
          store.state.lpb.lpb_name != ''
          ? store.state.lpb.lpb_name
          : 'State of New Mexico'
      case 'agentName':
        return store.state.entityInfo.agentName
      case 'employerDept':
        return store.state.entityInfo.entityDept
      case 'agentNumber':
        return store.state.entityInfo.agentNumber
      case 'agentNumberAlt':
        return store.state.entityInfo.agentNumberAlt
      case 'agentLastNameFirst5': {
        let nameArray = store.state.entityInfo.agentName.split(' ')
        if (nameArray.length) {
          let last = nameArray[nameArray.length - 1]

          if (last.length >= 5) return last.substr(0, 5).toUpperCase()
          else return last.toUpperCase()
        } else return ''
      }
    }

    if (
      fieldName.toLowerCase().indexOf('spouse') >= 0 &&
      fieldName.toLowerCase().indexOf('bene') < 0
    ) {
      let spouse = applicants.find(
        a => a.person.type.toLowerCase() === 'spouse'
      )

      if (!spouse) return ''

      let applicant = spouse.person

      if (applicant) {
        switch (fieldName) {
          case 'spouseName':
            if (formatRule === 'reverseName') {
              return (
                applicant.lastName +
                ',' +
                applicant.firstName +
                ' ' +
                applicant.middleName
              ).trim()
            } else {
              return applicant.name
            }
          case 'spouseFirstName':
            return applicant.firstName
          case 'spouseMiddleName':
            return applicant.middleName
          case 'spouseMI':
            return applicant.middleName.length
              ? applicant.middleName.substr(0, 1)
              : ''
          case 'spouseLastName':
            return applicant.lastName
          case 'spouseDOB':
            return applicant.birthdate
          case 'spouseEmail':
            return applicant.email
          case 'spouseSex':
            return applicant.sex
          case 'spouseAge':
            return applicant.age
        }
      }
    } else {
      let employee = applicants.find(
        a => a.person.type.toLowerCase() === 'employee'
      )

      if (!employee) return ''

      let applicant = employee.person

      let value = applicant.homePhone

      value = value.replace(/-/g, '')
      value = value.replace(/\./g, '')
      value = value.replace(/\(/g, '')
      value = value.replace(/\)/g, '')
      value = value.replace(/ /g, '')

      applicant.homePhoneForParsing = value

      value = applicant.workPhone

      value = value.replace(/-/g, '')
      value = value.replace(/\./g, '')
      value = value.replace(/\(/g, '')
      value = value.replace(/\)/g, '')
      value = value.replace(/ /g, '')

      applicant.workPhoneForParsing = value

      if (applicant) {
        switch (fieldName) {
          case 'employeeName':
            if (formatRule === 'reverseName') {
              return (
                applicant.lastName +
                ',' +
                applicant.firstName +
                ' ' +
                applicant.middleName
              ).trim()
            } else return applicant.name
          case 'employeeFirstName':
            return applicant.firstName
          case 'employeeMiddleName':
            return applicant.middleName
          case 'employeeMI':
            return applicant.middleName.length
              ? applicant.middleName.substr(0, 1)
              : ''
          case 'employeeLastName':
            return applicant.lastName
          case 'employeeAddr':
            return applicant.street
          case 'employeeCity':
            return applicant.city
          case 'employeeState':
            return applicant.state
          case 'employeeZip':
            return applicant.zip
          case 'employeeZipFirst5':
            return applicant.zip.substr(0, 5)
          case 'employeeZipLast4': {
            if (applicant.zip.length == 9) {
              return applicant.zip.substr(5, 4)
            }

            return ''
          }
          case 'employeePhone':
            return applicant.homePhone
          case 'employeePhoneArea': {
            if (applicant.homePhoneForParsing.length == 11) {
              return applicant.homePhoneForParsing.substr(1, 3)
            } else {
              return applicant.homePhoneForParsing.substr(0, 3)
            }
          }
          case 'employeePhoneFirstThree': {
            if (applicant.homePhoneForParsing.length == 11) {
              return applicant.homePhoneForParsing.substr(4, 3)
            } else {
              return applicant.homePhoneForParsing.substr(3, 3)
            }
          }
          case 'employeePhoneLastFour': {
            if (applicant.homePhoneForParsing.length == 11) {
              return applicant.homePhoneForParsing.substr(7, 4)
            } else {
              return applicant.homePhoneForParsing.substr(6, 4)
            }
          }
          case 'employeeWorkPhone':
            return applicant.workPhone

          case 'employeeWorkPhoneArea': {
            if (applicant.workPhoneForParsing.length < 10) return ''
            else if (applicant.workPhoneForParsing.length == 11) {
              return applicant.workPhoneForParsing.substr(1, 3)
            } else {
              return applicant.workPhoneForParsing.substr(0, 3)
            }
          }
          case 'employeeWorkPhoneFirstThree': {
            if (applicant.workPhoneForParsing.length < 10) return ''
            else if (applicant.workPhoneForParsing.length == 11) {
              return applicant.workPhoneForParsing.substr(4, 3)
            } else {
              return applicant.workPhoneForParsing.substr(3, 3)
            }
          }
          case 'employeeWorkPhoneLastFour': {
            if (applicant.workPhoneForParsing.length < 10) return ''
            else if (applicant.workPhoneForParsing.length == 11) {
              return applicant.workPhoneForParsing.substr(7, 4)
            } else {
              return applicant.workPhoneForParsing.substr(6, 4)
            }
          }

          case 'employeeEmail':
            return applicant.email
          case 'employeeSex':
            return applicant.sex
          case 'employeeAge':
            return applicant.age
          case 'employeeDOB':
            return applicant.birthdate
          case 'employer':
            return applicant.employer
          case 'employerCity':
            return applicant.employerCity
          case 'employerState':
            return applicant.employerState
          case 'spouseOrOtherBene':
            return applicant.beneRadioBtn
          case 'beneficiary':
            return applicant.otherBene
        }
      }
    }

    return ''
  },
  uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },
  applyFormatRule(rule, input) {
    let value = input

    if (!input) return ''

    switch (rule) {
      case 'zip':
        {
          if (input.length === 5) {
            value = input
          } else if (input.length === 9) {
            value = input.slice(0, 5) + '-' + input.slice(5, 9)
          }
        }
        break

      // case 'reverseName':
      //   {
      //     let suffixes = [
      //       'jr',
      //       'sr',
      //       'md',
      //       'phd',
      //       'ii',
      //       'iii',
      //       'iv',
      //       'v',
      //       'vi',
      //       'vii'
      //     ]

      //     let nameParts = input.replace(/,/g, '').split(' ')

      //     if (nameParts && nameParts.length >= 2) {
      //       let reverse = nameParts[nameParts.length - 1]

      //       let test = reverse
      //       test = test.replace(/\./g, '').toLowerCase()

      //       if (suffixes.findIndex(s => s === test) >= 0) {
      //         reverse =
      //           nameParts[nameParts.length - 2] +
      //           ' ' +
      //           nameParts[nameParts.length - 1]

      //         let idx = 0

      //         while (idx < nameParts.length - 2) {
      //           if (idx === 0) {
      //             reverse += ','
      //           }
      //           reverse += ' ' + nameParts[idx]
      //           idx++
      //         }
      //       } else {
      //         let idx = 0

      //         while (idx < nameParts.length - 1) {
      //           if (idx === 0) {
      //             reverse += ','
      //           }
      //           reverse += ' ' + nameParts[idx]
      //           idx++
      //         }
      //       }

      //       value = reverse
      //     }
      //   }
      //   break

      case 'money':
        {
          let amt = ''

          if (Math.floor(parseFloat(value)) === parseFloat(value))
            amt = value.toString().split('.')[0]
          else amt = parseFloat(value).toFixed(2)

          var parts = amt.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          value = '$' + parts.join('.')
        }
        break

      case 'state':
        {
          let idx = states.findIndex(s => s.name === value.toUpperCase())
          if (idx >= 0) value = states[idx].abbreviation
        }
        break

      case 'phone':
        if (value.length === 10) {
          let ph =
            value.substr(0, 3) +
            '-' +
            value.substr(3, 3) +
            '-' +
            value.substr(6, 4)
          value = ph
        } else if (value.length === 11 && value[0] === '1') {
          let ph =
            value.substr(1, 3) +
            '-' +
            value.substr(4, 3) +
            '-' +
            value.substr(7, 4)
          value = ph
        } else if (value.length === 11) {
          // To Do: Verify this structure passes SignNow's phone validation
          let ph =
            value.substr(0, 1) +
            '-' +
            value.substr(1, 3) +
            '-' +
            value.substr(4, 3) +
            '-' +
            value.substr(7, 4)
          value = ph
        }

        break
    }

    return value
  },
  meetsAgeReqs(person, ageReqs) {
    let exclude = false
    if (ageReqs.minAgeDays) {
      if (person.ageInDays && person.ageInDays < ageReqs.minAgeDays)
        exclude = true
    }
    if (ageReqs.maxAgeDays) {
      if (person.ageInDays && person.ageInDays > ageReqs.maxAgeDays)
        exclude = true
    }
    if (ageReqs.maxAgeYears) {
      if (person.age > ageReqs.maxAgeYears) exclude = true
    }
    if (ageReqs.minAgeYears) {
      if (person.age < ageReqs.minAgeYears) exclude = true
    }
    return !exclude
  },
  buildBody() {
    // intialize the empty body:

    let AIs = store.getters.applicableIndividuals
    let AIidx = AIs.findIndex(a => a.type === 'employee')

    let docGroupId = 'Document Group'

    if (AIidx >= 0) {
      docGroupId = AIs[AIidx].name + ' Document Group' //this.uuid()
    }

    let body = {
      templates: [],
      signers: [],
      documentGroup: {
        name: docGroupId
      },
      emailInfo: {
        agentName: store.state.entityInfo.agentName,
        agentPhone: store.state.entityInfo.agentPhone
      }
    }

    // Get applicants with their product selections:

    let peopleAndProducts = []
    // let childRider = false
    // let ageReqs = {}

    for (let s = 0; s < store.state.selections.length; s++) {
      if (store.state.selections[s]) {
        let si = this.findSelectionInfo(store.state.selections[s])

        if (si) peopleAndProducts.push(si)

        // if (si.rider && si.rider.type === 'CR') {
        //   childRider = true
        //   ageReqs = si.rider.requirements.employee.age_child
        // }
      }
    }

    let templates = []

    // Associate rates with the product selections:
    for (let p = 0; p < peopleAndProducts.length; p++) {
      // find the stored rate for this person's product selection

      let idx = store.state.rates.findIndex(
        r =>
          r.personId === peopleAndProducts[p].person.id &&
          r.planCodeId === peopleAndProducts[p].product.planCodeId
      )

      // initialize the rate to undefined
      peopleAndProducts[p].rate = undefined

      // if the rate was found in the store, associate the face amount
      // and weekly premium with the person/product selection object
      // for later use.
      if (idx >= 0) {
        peopleAndProducts[p].rate = {
          faceAmt: store.state.rates[idx].faceAmt,
          premium: store.state.rates[idx].premium
        }
      } else {
        // No applicable rate, and not a child covered under child rider
        peopleAndProducts.splice(p, 1)
        p--
      }
    }

    // if (
    //   store.state.cancerPrimaryApplicant &&
    //   store.state.cancerPrimaryApplicant.person
    // ) {
    //   let idx = store.state.rates.findIndex(
    //     r =>
    //       r.personId === store.state.cancerPrimaryApplicant.person.id &&
    //       r.planCodeId === store.state.cancerPrimaryApplicant.product.planCodeId
    //   )

    //   if (idx >= 0) {
    //     let rate = {
    //       faceAmt: store.state.rates[idx].faceAmt,
    //       premium: store.state.rates[idx].premium
    //     }

    //     store.commit('setCancerPrimaryApplicantRate', rate)
    //   } else {
    //     store.commit('setCancerPrimaryApplicantRate', undefined)
    //   }
    // }

    // if (childRider) {
    //   for (let ind of store.getters.applicableIndividuals) {

    //     let pIdx = peopleAndProducts.findIndex(p => p.person.id === ind.id)

    //     if (pIdx < 0) {
    //       // not found

    //       if (
    //         ind.type.toLowerCase() === 'child' &&
    //         this.meetsAgeReqs(ind, ageReqs)
    //       ) {
    //         let personAndProduct = {
    //           isSigner: false,
    //           person: ind,
    //           product: {
    //             id: -1,
    //             planCodeId: '000',
    //             planCode: ''
    //           },
    //           rate: {
    //             faceAmt: 0,
    //             premium: 0
    //           },
    //           rider: undefined
    //         }

    //         peopleAndProducts.push(personAndProduct)
    //       }
    //     }
    //   }
    // }

    for (let idx = 0; idx < peopleAndProducts.length; idx++) {
      let applicableRates = store.state.rates.filter(
        r => r.personId === peopleAndProducts[idx].person.id
      )

      for (let rate of applicableRates) {
        if (rate.rider && rate.rider.type != 'DFR') {
          let index = rate.rider.planCodes.findIndex(
            p => p === peopleAndProducts[idx].product.planCodeId
          )

          if (index != undefined && index >= 0) {
            peopleAndProducts[idx].rate.premium = (
              parseFloat(peopleAndProducts[idx].rate.premium) +
              parseFloat(rate.premium)
            ).toString()
          }
        }
      }
    }

    // initialize array for all signers

    let childSignersIdx = 0
    let childGIRecipientsIdx = 0
    body.giRecipients = []

    // Determine if the person is a signer for this plan code
    // taking age and guarantee issue into account.

    for (let p = 0; p < peopleAndProducts.length; p++) {
      // See if this applicant meets the guarantee issue requirements
      // for over guarantee issue:

      if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
        continue
      }

      if (
        this.meetsAgeAndGuaranteeIssueReqsIncludeChildren(
          peopleAndProducts[p]
        ) &&
        peopleAndProducts[p].product.planCodeId != '000'
      ) {
        peopleAndProducts[p].isOverGIRecipient = true
      } else {
        peopleAndProducts[p].isOverGIRecipient = false
      }

      if (peopleAndProducts[p].person.type.toLowerCase() == 'employee') {
        peopleAndProducts[p].isOverGIRecipient = true
      }

      if (peopleAndProducts[p].isOverGIRecipient === true) {
        let idx = body.giRecipients.findIndex(
          s => s.id === peopleAndProducts[p].person.id
        )

        if (idx < 0) {
          let giRecipient = {
            id: peopleAndProducts[p].person.id,
            email: peopleAndProducts[p].person.email,
            type: peopleAndProducts[p].person.type,
            name: peopleAndProducts[p].person.name,
            role: '',
            documents: []
          }

          if (giRecipient.type === 'employee') {
            giRecipient.role = 'Employee'
          } else if (giRecipient.type === 'spouse') {
            giRecipient.role = 'Spouse'
          } else if (giRecipient.type === 'child') {
            childGIRecipientsIdx++
            giRecipient.role = 'Child_' + childGIRecipientsIdx.toString()
          }

          body.giRecipients.push(giRecipient)
        }
      }

      // if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
      //   // if cancer product, find cancer signers

      //   let buckets = store.state.cancerAppBuckets

      //   if (peopleAndProducts[p].isCancerSigner == undefined) {
      //     peopleAndProducts[p].isCancerSigner = false
      //   }

      //   if (
      //     peopleAndProducts[p].person.type.toLowerCase() == 'applicant' ||
      //     peopleAndProducts[p].person.type.toLowerCase == 'employee'
      //   ) {
      //     peopleAndProducts[p].isCancerSigner = true
      //   }

      //   for (let bucket of buckets) {
      //     if (
      //       bucket.oldestApplicant.person.id == peopleAndProducts[p].person.id
      //     ) {
      //       if (
      //         peopleAndProducts[p].person.type.toLowerCase() != 'child' ||
      //         peopleAndProducts[p].person.age >= 19
      //       ) {
      //         peopleAndProducts[p].isCancerSigner = true
      //       }

      //       break
      //     }
      //   }
      // } else
      {
        if (
          body.signers.findIndex(s => s.type.toLowerCase() === 'employee') < 0
        ) {
          let emp = store.getters.applicableIndividuals.filter(
            a => a.type.toLowerCase() === 'employee'
          )
          if (emp && emp.length > 0) {
            body.signers.push({
              id: emp[0].id,
              email: emp[0].email,
              type: emp[0].type,
              name: emp[0].name,
              dob: emp[0].birthdate,
              role: 'Employee',
              documents: []
            })
          }
        }

        // See if this applicant meets the age/guarantee issue requirements
        // to be a signer:
        if (
          this.meetsAgeAndGuaranteeIssueReqs(peopleAndProducts[p]) &&
          peopleAndProducts[p].product.planCodeId != '000'
        ) {
          peopleAndProducts[p].isSigner = true
        } else {
          peopleAndProducts[p].isSigner = false
        }

        if (peopleAndProducts[p].isSigner === true) {
          let idx = body.signers.findIndex(
            s => s.id === peopleAndProducts[p].person.id
          )

          if (idx < 0) {
            let signer = {
              id: peopleAndProducts[p].person.id,
              email: peopleAndProducts[p].person.email,
              type: peopleAndProducts[p].person.type,
              name: peopleAndProducts[p].person.name,
              dob: peopleAndProducts[p].person.birthdate,
              role: '',
              documents: []
            }

            if (signer.type === 'employee') {
              signer.role = 'Employee'
            } else if (signer.type === 'spouse') {
              signer.role = 'Spouse'
            } else if (signer.type === 'child') {
              childSignersIdx++
              signer.role = 'Child_' + childSignersIdx.toString()
            }

            if (
              body.signers.findIndex(
                s => s.id == peopleAndProducts[p].person.id
              ) < 0
            )
              body.signers.push(signer)
          }
        }
      }

      // console.log(body.signers);

      // Determine which templates are applicable for this
      // particular person & product selection

      let temps = this.planTemplates.find(
        t => t.planCode === peopleAndProducts[p].product.planCodeId
      )

      let applicableTemplates = undefined
      if (temps) applicableTemplates = temps.templates
      if (applicableTemplates && applicableTemplates.length > 0) {
        // for each template applicable for this person/product selection:
        for (let a = 0; a < applicableTemplates.length; a++) {
          // Determine if we've already added this template to the templates' list
          let idx = templates.findIndex(
            t => t.templateId === applicableTemplates[a]
          )

          // if the definition was found
          if (idx >= 0) {
            // Build the list of applicants applicable to this template definition:

            // First check if the applicant exists in the templates' applicants list
            let applicant = templates[idx].applicants.findIndex(
              app => app.person.id === peopleAndProducts[p].person.id
            )

            let isSigner = peopleAndProducts[p].isSigner

            // if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
            //   isSigner = peopleAndProducts[p].isCancerSigner
            // }

            // If the applicant was not found in the list, add him/her
            if (applicant < 0) {
              templates[idx].applicants.push({
                // add the applicant
                person: peopleAndProducts[p].person,
                plans: [
                  {
                    // add the applicant's product selection
                    product: peopleAndProducts[p].product,
                    // add the applicable rate for the applicant's product selection
                    rate: peopleAndProducts[p].rate,

                    isSigner: isSigner, // sig required for this plan

                    isOverGIRecipient: peopleAndProducts[p].isOverGIRecipient
                  }
                ]
              })
            }
            // otherwise, if the applicant was located, add to his/her product selections list
            else {
              templates[idx].applicants[applicant].plans.push({
                // add this product selection
                product: peopleAndProducts[p].product,
                // add the applicable rate for the product selection
                rate: peopleAndProducts[p].rate,

                isSigner: isSigner, // sig required for this plan

                isOverGIRecipient: peopleAndProducts[p].isOverGIRecipient
              })
            }

            // Build the list of signers applicable to this template definition:

            // See if this person is already in the signers' list
            let signer = templates[idx].signers.findIndex(
              s => s.person.id === peopleAndProducts[p].person.id
            )

            // If the person is not in the list, add him/her
            // if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
            //   if (signer < 0 && peopleAndProducts[p].isCancerSigner === true) {
            //     templates[idx].signers.push({
            //       // add person demographic info
            //       person: peopleAndProducts[p].person
            //     })
            //   }
            // } else

            if (signer < 0 && peopleAndProducts[p].isSigner === true) {
              templates[idx].signers.push({
                // add person demographic info
                person: peopleAndProducts[p].person
              })
            }
          }

          // else if we haven't added this template to the list yet
          else {
            // Get the template information from the template-definitions
            let tdIdx = this.definitions.findIndex(
              d => d.id == applicableTemplates[a]
            )

            if (tdIdx >= 0) {
              // if this template is NOT a primary template, do not add it to the templates' list
              // it will be added later as a related document.
              if (this.definitions[tdIdx].primary === false) continue
            } else {
              // if no template definition was found, skip the rest of the loop
              continue
            }

            let applicableSigners = []

            // if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
            //   if (peopleAndProducts[p].isCancerSigner) {
            //     applicableSigners = [
            //       {
            //         person: peopleAndProducts[p].person // the first applicable signer
            //       }
            //     ]
            //   }
            // } else

            if (peopleAndProducts[p].isSigner) {
              applicableSigners = [
                {
                  person: peopleAndProducts[p].person // the first applicable signer
                }
              ]
            }

            let isSigner = peopleAndProducts[p].isSigner

            // if (peopleAndProducts[p].product.name.indexOf('Cancer') >= 0) {
            //   isSigner = peopleAndProducts[p].isCancerSigner
            // }

            // Define the template for adding to the list:
            let template = {
              templateId: applicableTemplates[a], // the template id
              signers: applicableSigners,
              applicants: [
                {
                  person: peopleAndProducts[p].person, // the first applicable applicant
                  plans: [
                    {
                      product: peopleAndProducts[p].product, // the first applicable applicant's first selected plan
                      rate: peopleAndProducts[p].rate, // the rate associated with the first selected plan
                      isSigner: isSigner, // sig required for this plan
                      isOverGIRecipient: peopleAndProducts[p].isOverGIRecipient
                    }
                  ]
                }
              ],
              // isCancerTemplate: peopleAndProducts[p].product.name.indexOf('Cancer') >= 0 ? true: false,
              copies: 1 // initialize copies needed to 1 to start
            }

            // add the template to the templates array
            templates.push(template)
          }
        }
      }
    }

    // Add Cancer Templates

    let cancerAppBuckets = store.state.cancerAppBuckets
    for (let bucket of cancerAppBuckets) {
      let temps = this.planTemplates.find(
        t => t.planCode === bucket.oldestApplicant.product.planCodeId
      )

      let applicableTemplates = []
      if (temps) applicableTemplates.push(...temps.templates)

      for (let appTemp of applicableTemplates) {
        let tdIdx = this.definitions.findIndex(d => d.id == appTemp)

        if (tdIdx >= 0) {
          // if this template is NOT a primary template, do not add it to the templates' list
          // it will be added later as a related document.
          if (this.definitions[tdIdx].primary === false) continue
        } else {
          // if no template definition was found, skip the rest of the loop
          continue
        }

        let emp = store.getters.applicableIndividuals.find(
          p =>
            p.type.toLowerCase() == 'employee' ||
            p.type.toLowerCase() == 'applicant'
        )

        // employee always signs
        let applicableSigners = [
          {
            person: emp
          }
        ]

        if (body.signers.length == 0) {
          let signer = {
            id: emp.id,
            email: emp.email,
            type: emp.type,
            name: emp.name,
            dob: emp.birthdate,
            role: 'Employee',
            documents: []
          }

          body.signers.push(signer)
        }

        let template = {
          templateId: appTemp,
          signers: applicableSigners,
          applicants: [],
          isCancerTemplate: true,
          copies: 1 // initialize copies needed to 1 to start
        }

        let apps = []
        let applicants = []

        if (bucket.applicant) apps.push(bucket.applicant)
        if (bucket.spouse) apps.push(bucket.spouse)
        if (bucket.children) apps.push(...bucket.children)

        for (let appl of apps) {
          let idx = store.state.rates.findIndex(
            r =>
              r.personId === appl.person.id &&
              r.planCodeId === appl.product.planCodeId
          )

          // initialize the rate to undefined
          appl.rate = undefined

          // if the rate was found in the store, associate the face amount
          // and weekly premium with the person/product selection object
          // for later use.
          if (idx >= 0) {
            appl.rate = {
              faceAmt: store.state.rates[idx].faceAmt,
              premium: store.state.rates[idx].premium
            }
          }

          let applicant = {
            person: appl.person, // the first applicable applicant
            plans: [
              {
                product: appl.product, // the first applicable applicant's first selected plan
                rate: appl.rate, // the rate associated with the first selected plan
                isSigner:
                  appl.person.type.toLowerCase() == 'employee' ||
                  appl.person.type.toLowerCase() == 'applicant'
                    ? true
                    : false, // sig required for this plan
                isOverGIRecipient: false
              }
            ]
          }
          applicants.push(applicant)

          if (appl.person.id == bucket.oldestApplicant.person.id) {
            template.cancerApplicant = appl
            template.cancerApplicant.planCodeId = bucket.planCodeId
          }
        }
        if (apps.length == 1) {
          template.indCancerPlan = true
        } else {
          template.indCancerPlan = false
        }
        template.applicants.push(...applicants)
        templates.push(template)
      }
    }

    //  Add Required Templates

    if (this.requiredTemplates) {
      for (let r = 0; r < this.requiredTemplates.length; r++) {
        // To Do: Handle adding other applicants based on roles
        // associated with template

        let idx = peopleAndProducts.findIndex(
          p => p.person.type.toLowerCase() === 'employee'
        )

        if (idx >= 0) {
          let template = {
            templateId: this.requiredTemplates[r].template, // the template id
            signers: [
              {
                person: peopleAndProducts[idx].person // the first applicable signer
              }
            ],
            applicants: [
              {
                person: peopleAndProducts[idx].person, // the first applicable applicant
                plans: [
                  {
                    product: peopleAndProducts[idx].product, // the first applicable applicant's first selected plan
                    rate: peopleAndProducts[idx].rate // the rate associated with the first selected plan
                  }
                ]
              }
            ],
            copies: 1 // initialize copies needed to 1 to start
          }

          templates.push(template)
        } else {
          let emp = store.getters.applicableIndividuals.find(
            a => a.type.toLowerCase() === 'employee'
          )

          if (emp) {
            let template = {
              templateId: this.requiredTemplates[r].template, // the template id
              signers: [
                {
                  person: emp
                }
              ],
              applicants: [
                {
                  person: emp,
                  plans: []
                }
              ],
              copies: 1 // initialize copies needed to 1 to start
            }

            templates.push(template)
          }
        }
      }
    }

    // Add Templates Based on Questions

    let questions = store.state.questions
    let applyQuestions = false

    for (let personAndProduct of peopleAndProducts) {
      if (personAndProduct.product.name.indexOf('Life') >= 0)
        applyQuestions = true
    }

    if (questions && applyQuestions) {
      for (let q = 0; q < questions.length; q++) {
        if (questions[q].template && questions[q].template >= 0) {
          if (questions[q].radioBtnAnswer.toLowerCase() === 'yes') {
            let idx = peopleAndProducts.findIndex(
              p => p.person.type.toLowerCase() === 'employee'
            )

            if (idx >= 0) {
              let template = {
                templateId: questions[q].template, // the template id
                signers: [
                  {
                    person: peopleAndProducts[idx].person // the first applicable signer
                  }
                ],
                applicants: [
                  {
                    person: peopleAndProducts[idx].person, // the first applicable applicant
                    plans: [
                      {
                        product: peopleAndProducts[idx].product, // the first applicable applicant's first selected plan
                        rate: peopleAndProducts[idx].rate // the rate associated with the first selected plan
                      }
                    ]
                  }
                ],
                copies: 1 // initialize copies needed to 1 to start
              }

              templates.push(template)
            } else {
              let emp = store.getters.applicableIndividuals.find(
                a => a.type.toLowerCase() === 'employee'
              )

              if (emp) {
                let template = {
                  templateId: questions[q].template, // the template id
                  signers: [
                    {
                      person: emp
                    }
                  ],
                  applicants: [
                    {
                      person: emp,
                      plans: []
                    }
                  ],
                  copies: 1 // initialize copies needed to 1 to start
                }

                templates.push(template)
              }
            }
          }
        }
      }
    }

    // // Add Terminal Illness Rider Template

    let added = false

    for (let person of peopleAndProducts) {
      if (person.person.type.toLowerCase() === 'employee') {
        let TIRiderTemplateId = this.checkForTerminalIllnessTemplateId(
          person.person,
          person.product
        )

        if (TIRiderTemplateId > 0) {
          let template = {
            templateId: TIRiderTemplateId, // the template id
            signers: [
              {
                person: person.person // the first applicable signer
              }
            ],
            applicants: [
              {
                person: person.person, // the first applicable applicant
                plans: [
                  {
                    product: person.product, // the first applicable applicant's first selected plan
                    rate: person.rate // the rate associated with the first selected plan
                  }
                ]
              }
            ],
            copies: 1 // initialize copies needed to 1 to start
          }

          templates.push(template)
          added = true
        }
      }
    }

    if (!added) {
      let emp = store.getters.applicableIndividuals.find(
        a => a.type.toLowerCase() === 'employee'
      )

      if (emp) {
        for (let person of peopleAndProducts) {
          if (!added) {
            let TIRiderTemplateId = this.checkForTerminalIllnessTemplateId(
              person.person,
              person.product
            )

            if (TIRiderTemplateId > 0) {
              let template = {
                templateId: TIRiderTemplateId, // the template id
                signers: [
                  {
                    person: emp
                  }
                ],
                applicants: [
                  {
                    person: person.person, // the first applicable applicant
                    plans: [
                      {
                        product: person.product, // the first applicable applicant's first selected plan
                        rate: person.rate // the rate associated with the first selected plan
                      }
                    ]
                  }
                ],
                copies: 1 // initialize copies needed to 1 to start
              }

              templates.push(template)
              added = true
            }
          }
        }
      }
    }

    // // Add Deposit Fund Rider Template

    added = false

    for (let person of peopleAndProducts) {
      if (person.person.type.toLowerCase() === 'employee') {
        let DFRiderTemplateId = this.checkForDepositFundTemplateId(
          person.person,
          person.product
        )

        if (DFRiderTemplateId > 0) {
          let template = {
            templateId: DFRiderTemplateId, // the template id
            signers: [
              {
                person: person.person // the first applicable signer
              }
            ],
            applicants: [
              {
                person: person.person, // the first applicable applicant
                plans: [
                  {
                    product: person.product, // the first applicable applicant's first selected plan
                    rate: person.rate // the rate associated with the first selected plan
                  }
                ]
              }
            ],
            copies: 1 // initialize copies needed to 1 to start
          }

          templates.push(template)
          added = true
        }
      }
    }

    if (!added) {
      let emp = store.getters.applicableIndividuals.find(
        a => a.type.toLowerCase() === 'employee'
      )

      if (emp) {
        for (let person of peopleAndProducts) {
          if (!added) {
            let DFRiderTemplateId = this.checkForDepositFundTemplateId(
              person.person,
              person.product
            )

            if (DFRiderTemplateId > 0) {
              let template = {
                templateId: DFRiderTemplateId, // the template id
                signers: [
                  {
                    person: emp
                  }
                ],
                applicants: [
                  {
                    person: person.person, // the first applicable applicant
                    plans: [
                      {
                        product: person.product, // the first applicable applicant's first selected plan
                        rate: person.rate // the rate associated with the first selected plan
                      }
                    ]
                  }
                ],
                copies: 1 // initialize copies needed to 1 to start
              }

              templates.push(template)
              added = true
            }
          }
        }
      }
    }

    // Add children for child riders
    for (let t = 0; t < templates.length; t++) {
      if (templates[t].isCancerTemplate == true) continue

      let childRider = false
      let ageReqs = {}

      for (let applicant of templates[t].applicants) {
        for (let s = 0; s < store.state.selections.length; s++) {
          if (store.state.selections[s]) {
            let si = this.findSelectionInfo(store.state.selections[s])

            if (si.person.id === applicant.person.id) {
              if (si.rider && si.rider.type === 'CR') {
                childRider = true
                ageReqs = si.rider.requirements.employee.age_child
              }
            }
          }
        }
      }

      if (childRider) {
        for (let ind of store.getters.applicableIndividuals) {
          let pIdx = templates[t].applicants.findIndex(
            p => p.person.id === ind.id
          )

          if (pIdx < 0) {
            // not found

            if (
              ind.type.toLowerCase() === 'child' &&
              this.meetsAgeReqs(ind, ageReqs)
            ) {
              let applicant = {
                person: ind,
                plans: [
                  {
                    product: {
                      id: -1,
                      planCodeId: '000',
                      planNumber: ''
                    },
                    rate: {
                      faceAmt: 0,
                      premium: 0
                    }
                  }
                ]
              }

              templates[t].applicants.push(applicant)
            }
          }
        }
      }
    }

    // Adjust number of copies of each template needed:

    let apiTemplateId = 0

    // loop through our primary templates:
    for (let t = 0; t < templates.length; t++) {
      // Get the template definition data for this template
      let tdIdx = this.definitions.findIndex(
        d => d.id == templates[t].templateId
      )

      // if the definition exists:
      if (tdIdx >= 0) {
        // if this is template is a primary (first page) template:
        if (this.definitions[tdIdx].primary) {
          // grab the information from the definitions lookup and
          // associate it with the template in the array we're building

          templates[t].templateId = this.definitions[tdIdx].id
          templates[t].documentName = this.definitions[tdIdx].documentName
          templates[t].documentId = this.definitions[tdIdx].documentId
          templates[t].snTemplateId = this.definitions[tdIdx].snTemplateId
          templates[t].dsTemplateId = this.definitions[tdIdx].dsTemplateId
          templates[t].dsTemplateIdSpouse = this.definitions[
            tdIdx
          ].dsTemplateIdSpouse
          templates[t].dsTemplateIdChild = this.definitions[
            tdIdx
          ].dsTemplateIdChild
          templates[t].secondaryTemplateId = this.definitions[
            tdIdx
          ].secondaryTemplateId
          templates[t].primary = this.definitions[tdIdx].primary

          // initialize the templates' repeat types to empty array
          templates[t].repeatTypes = []

          // Make sure employee is in signers for primary templates:

          // marker
          if (templates[t].primary) {
            let Ok = false

            for (let signer of templates[t].signers) {
              if (signer.person.type.toLowerCase() === 'employee') Ok = true
            }

            if (!Ok) {
              let emp = store.getters.applicableIndividuals.filter(
                s => s.type.toLowerCase() == 'employee'
              )

              if (templates[t].signers === undefined) templates[t].signers = []

              if (emp && emp.length > 0) {
                templates[t].signers.push({ person: emp[0] })
              }
            }

            Ok = false
            for (let applicant of templates[t].applicants) {
              if (applicant.person.type.toLowerCase() === 'employee') Ok = true
            }

            if (!Ok) {
              let emp = store.getters.applicableIndividuals.filter(
                s => s.type.toLowerCase() == 'employee'
              )
              if (emp && emp.length > 0) {
                templates[t].applicants.push({
                  person: emp[0],
                  product: undefined,
                  rider: undefined,
                  plans: []
                })
              }
            }
          }

          // look for the template rules associate with this template
          let rulesIdx = this.rules.findIndex(
            r => r.templateId === templates[t].templateId
          )

          // if we've found some rules:
          if (rulesIdx >= 0) {
            // associate the rules with the template for later use
            templates[t].rules = this.rules[rulesIdx]

            // if there are repeat types listed in the rules for this template
            // go through them one by one
            if (this.rules[rulesIdx].repeatTypes) {
              for (
                let r = 0;
                r < this.rules[rulesIdx].repeatTypes.length;
                r++
              ) {
                // look up the repeat type id in the repeat types results
                let repeatIdx = this.repeatTypes.findIndex(
                  rt => rt.id === this.rules[rulesIdx].repeatTypes[r]
                )

                // if we've located the repeat type
                if (repeatIdx >= 0) {
                  // add the repeat type data to the template's repeat types array
                  templates[t].repeatTypes.push(
                    this.repeatTypes[repeatIdx].type
                  )

                  // process the repeat type
                  switch (this.repeatTypes[repeatIdx].type) {
                    case 'pi':
                      // Repeat the template for each proposed insured
                      if (templates[t].copies < templates[t].signers.length) {
                        templates[t].copies = templates[t].signers.length
                      }
                      break

                    case 'gi_separate': {
                      let employeeProducts = peopleAndProducts.filter(
                        p => p.person.type.toLowerCase() === 'employee'
                      )

                      let includeEmployee = false

                      for (let empProd of employeeProducts) {
                        if (empProd.product.name.indexOf('Life') >= 0)
                          includeEmployee = true
                      }

                      if (templates[t].copies < templates[t].signers.length) {
                        templates[t].copies = templates[t].signers.length
                      }

                      if (includeEmployee == false) {
                        templates[t].copies -= 1
                      }

                      break
                    }
                    case 'gi':
                      // Repeat the template for each pi over guaranteed issue

                      // gi marker

                      for (
                        let apps = 0;
                        apps < templates[t].applicants.length;
                        apps++
                      ) {
                        if (
                          templates[t].applicants[apps].person.type ===
                            'employee' ||
                          templates[t].applicants[apps].person.type ===
                            'applicant'
                        )
                          continue

                        for (let plan of templates[t].applicants[apps].plans) {
                          let idx = peopleAndProducts.findIndex(
                            p =>
                              p.person.id ==
                                templates[t].applicants[apps].person.id &&
                              p.product.planCodeId == plan.product.planCodeId
                          )

                          if (
                            idx >= 0 &&
                            this.meetsAgeAndGuaranteeIssueReqsIncludeChildren(
                              peopleAndProducts[idx]
                            )
                          ) {
                            templates[t].copies++
                            break
                          }
                        }
                      }

                      break

                    case 'child':
                      // Repeat for excess number of children
                      {
                        let totalChildApplicants = 0

                        // find out how many children are allowed per page for this template
                        let maxChildrenPerPage = this.rules[rulesIdx].childCount

                        // loop through the template's related applicants
                        for (
                          let apps = 0;
                          apps < templates[t].applicants.length;
                          apps++
                        ) {
                          // if the applicant is a child, incrememnt the child counter
                          if (
                            templates[t].applicants[apps].person.type ===
                            'child'
                          ) {
                            totalChildApplicants++
                          }
                        }

                        // if we have more child applicants than are allowed on a single page
                        if (totalChildApplicants > maxChildrenPerPage) {
                          // Determine how many pages we need by dividing the number of children
                          // by the number of children per page and rounding up

                          let pagesNeeded = Math.ceil(
                            totalChildApplicants / maxChildrenPerPage
                          )

                          // if we need more pages than we've allowed for so far, increase the number
                          // of copies needed associated with this template
                          if (pagesNeeded > templates[t].copies) {
                            templates[t].copies = pagesNeeded
                          }
                        }
                      }
                      break
                    case 'plan':
                      // Repeat for excess number of plans
                      {
                        // Find the most number of plans any applicant has for this template:

                        let maxPlans = 1

                        // for each applicant associated with this template:
                        for (
                          let apps = 0;
                          apps < templates[t].applicants.length;
                          apps++
                        ) {
                          // if this applicant has the most plans of any applicant we've looked at so far
                          // set the maximum plans found counter to the number of plans this applicant has
                          if (
                            templates[t].applicants[apps].plans.length >
                            maxPlans
                          ) {
                            maxPlans =
                              templates[t].applicants[apps].plans.length
                          }
                        }

                        // Determine how many plan codes each page supports and then how many
                        // pages are needed to accommodate the applicant with the most plans:

                        if (maxPlans > this.rules[rulesIdx].planCount) {
                          // See how many pages we need by dividing the maximum number of plans
                          // by the number of plans allowed per page by this template and rounding up

                          let pagesNeeded = Math.ceil(
                            maxPlans / this.rules[rulesIdx].planCount
                          )

                          // if we don't have at least this number of pages set aside for this template,
                          // increase the copy count
                          if (pagesNeeded > templates[t].copies) {
                            templates[t].copies = pagesNeeded
                          }
                        }
                      }

                      break
                    case 'signature':
                      // if there are too many child signatures for the page, add additional pages
                      // to accomodate all signatures
                      {
                        let numChildSignatures = 0

                        // Count the number of applicable signers that qualify as children:

                        // Loop through the applicable signers (not all applicants are signers)
                        // and see how many of them are children of the primary employee:
                        for (
                          let apps = 0;
                          apps < templates[t].signers.length;
                          apps++
                        ) {
                          if (
                            templates[t].signers[apps].person.type === 'child'
                          ) {
                            numChildSignatures++
                          }
                        }

                        // if we require more child signatures than we have room for on one page:
                        if (
                          numChildSignatures >
                          this.rules[rulesIdx].childSignatureCount
                        ) {
                          // divide the number of child signatures we need by the number each page
                          // can accommodate and round up to get the number of pages we need

                          let pagesNeeded = Math.ceil(
                            numChildSignatures /
                              this.rules[rulesIdx].childSignatureCount
                          )

                          // if we need more pages than we have copies set aside, increase the copy count
                          if (pagesNeeded > templates[t].copies)
                            templates[t].copies = pagesNeeded
                        }
                      }
                      break

                    // if we don't recognize the rule, don't do anything:
                    default:
                      break
                  }
                }
              }
            }

            let pages = this.determineChildrenPerPage(templates[t], body)

            if (pages && pages.length > templates[t].copies)
              templates[t].copies = pages.length
          }

          // if (templates[t].isCancerTemplate == true) {
          //   templates[t].copies = store.state.cancerAppBuckets.length
          // }
        }
      }

      // Now that we know how many copies of the primary document we need
      // We need to see whether the copies are secondary/tertiary templates
      // or actual copies of the primary template

      // initialize the template's related documents to empty array
      templates[t].relatedDocuments = []

      // assuming we need at least one copy of this template (this should always be true)
      if (templates[t].copies > 0) {
        // for each copy we need:
        for (let i = 0; i < templates[t].copies; i++) {
          // initialize with the primary template's information
          let documentName = templates[t].documentName
          let snTemplateId = templates[t].snTemplateId
          let dsTemplateId = templates[t].dsTemplateId
          let templateId = templates[t].templateId
          let primary = true

          // if this isn't the first page, and the template's secondary template
          // isn't the same as the primary template
          if (
            i > 0 &&
            templates[t].secondaryTemplateId != templates[t].templateId
          ) {
            // get the defintion info for the secondary template id
            let def = this.definitions.find(
              d => d.id === templates[t].secondaryTemplateId
            )

            // if we've found the definition
            if (def) {
              // override with the secondary template's information
              snTemplateId = def.snTemplateId
              dsTemplateId = def.dsTemplateId
              documentName = def.documentName
              templateId = def.id
              primary = false
            }
          }
          // create the template copy object from the information gathered above:
          let copy = {
            templateId: templateId,
            snTemplateId: snTemplateId,
            dsTemplateId: dsTemplateId,
            documentName: documentName,
            copyNumber: i + 1,
            primary: primary,
            signers: [],
            applicants: [],
            planCount: 0,
            childrenCount: 0,
            childSignaturesCount: 0
          }

          // find the role mappings for this template id (should this be the copy's template id???)
          let applicableRoles = this.roleMappings.filter(
            r => r.templateId === templates[t].templateId
          )

          // for each applicable role
          for (let a = 0; a < applicableRoles.length; a++) {
            // look up what we're calling the role in the code
            let role = this.roles.find(
              r => r.id === applicableRoles[a].mapToRoleId
            )

            // if the lookup was successful, set the role name
            if (role) {
              applicableRoles[a].roleType = role.roleName
            }
            // otherwise, the role is unrecognized  (misconfiguration)
            else {
              applicableRoles[a].roleType = 'UNKNOWN'
            }
          }

          // if the template is a primary, but the repeat type is by pi (Proposed Insured)
          // then we need a copy for each of the applicants that meets the age and guarantee issue
          // requirements - i.e. the signers.

          if (
            copy.primary &&
            templates[t].repeatTypes.findIndex(rt => rt === 'pi') >= 0
          ) {
            // look up the role index for proposed insured
            let roleIdx = applicableRoles.findIndex(
              a => a.roleType.toLowerCase() === 'proposedinsured'
            )

            let role = ''
            let signerIdx = body.signers.findIndex(
              s => s.id === templates[t].signers[copy.copyNumber - 1].person.id
            )

            if (signerIdx >= 0) {
              role = body.signers[signerIdx].role
            }

            // if the role index was found:
            if (roleIdx >= 0) {
              // if there's a signer that corresponds to the copy number of this copy
              if (templates[t].signers[copy.copyNumber - 1]) {
                // add the signer to the copy's signer's list
                copy.signers.push({
                  // the signer him/herself
                  signer: templates[t].signers[copy.copyNumber - 1],
                  // the signer's role as it appears on the SignNow template
                  role: applicableRoles[roleIdx].templateRoleName,
                  // the signer's role as the code is aware of it -
                  // the lambda service call will map template role to this role
                  // during the course of prefilling the template's information
                  mapRole: role,

                  signOrView: applicableRoles[roleIdx].signOrView
                })
              }
            }
          } else if (
            templates[t].repeatTypes.findIndex(rt => rt === 'gi') >= 0
          ) {
            copy.giRecipients = []

            let roleIdx = applicableRoles.findIndex(
              a => a.roleType.toLowerCase() === 'proposedinsured'
            )

            if (roleIdx >= 0) {
              let giCntr = 0

              for (let a of templates[t].applicants) {
                if (a.plans[0] && a.plans[0].isOverGIRecipient) {
                  giCntr++

                  if (giCntr == copy.copyNumber) {
                    let role = ''

                    let signerIdx = body.signers.findIndex(
                      s => s.id == a.person.id
                    )

                    if (signerIdx >= 0) {
                      role = body.signers[signerIdx].role
                      // add the signer to the copy's signer's list
                      copy.signers.push({
                        // the signer him/herself
                        signer: { person: a.person },
                        // the signer's role as it appears on the SignNow template
                        role: applicableRoles[roleIdx].templateRoleName,
                        // the signer's role as the code is aware of it -
                        // the lambda service call will map template role to this role
                        // during the course of prefilling the template's information
                        mapRole: role,
                        signOrView: applicableRoles[roleIdx].signOrView,
                        applicant: { person: a.person }
                      })
                    } else {
                      let signer = a.person
                      for (let person of peopleAndProducts) {
                        if (person.person.type.toLowerCase() === 'employee') {
                          signer = person.person
                        }
                      }

                      copy.signers.push({
                        signer: { person: signer },
                        role: applicableRoles[roleIdx].templateRoleName,
                        mapRole: 'Employee',
                        signOrView: applicableRoles[roleIdx].signOrView,
                        applicant: { person: a.person }
                      })
                    }
                  }
                } else if (
                  (!a.plans || a.plans.length == 0) &&
                  a.person.type.toLowerCase() == 'employee'
                ) {
                  giCntr++

                  if (giCntr == copy.copyNumber) {
                    let signer = a.person

                    copy.signers.push({
                      signer: { person: signer },
                      role: applicableRoles[roleIdx].templateRoleName,
                      mapRole: 'Employee',
                      signOrView: applicableRoles[roleIdx].signOrView,
                      applicant: { person: a.person }
                    })
                  }
                }
              }
            }
          } else if (
            templates[t].repeatTypes.findIndex(rt => rt === 'gi_separate') >= 0
          ) {
            let tempSigners = []

            tempSigners.push(...templates[t].signers)

            let employeeProducts = peopleAndProducts.filter(
              p => p.person.type.toLowerCase() === 'employee'
            )

            let includeEmployee = false

            for (let empProd of employeeProducts) {
              if (empProd.product.name.indexOf('Life') >= 0)
                includeEmployee = true
            }

            if (includeEmployee == false) {
              // hold
              let idx = tempSigners.findIndex(t => t.person.type == 'employee')

              try {
                if (idx >= 0) tempSigners.splice(idx, 1)
              } catch (e) {
                log(e.toString(), true, 'logic.js buildBody')
              }
            }

            // look up the role index for proposed insured
            let roleIdx = applicableRoles.findIndex(
              a => a.roleType.toLowerCase() === 'proposedinsured'
            )

            let role = ''
            let signerIdx = body.signers.findIndex(
              s => s.id === tempSigners[copy.copyNumber - 1].person.id
            )

            if (signerIdx >= 0) {
              role = body.signers[signerIdx].role
            }

            if (role.toLowerCase() == 'spouse') {
              copy.dsTemplateId = templates[t].dsTemplateIdSpouse
            } else if (role.toLowerCase().indexOf('child') >= 0) {
              copy.dsTemplateId = templates[t].dsTemplateIdChild
            }

            // if the role index was found:
            if (roleIdx >= 0) {
              // if there's a signer that corresponds to the copy number of this copy
              if (tempSigners[copy.copyNumber - 1]) {
                // add the signer to the copy's signer's list
                copy.signers.push({
                  // the signer him/herself
                  signer: tempSigners[copy.copyNumber - 1],
                  // the signer's role as it appears on the SignNow template
                  role: applicableRoles[roleIdx].templateRoleName,
                  // the signer's role as the code is aware of it -
                  // the lambda service call will map template role to this role
                  // during the course of prefilling the template's information
                  mapRole: role,

                  signOrView: applicableRoles[roleIdx].signOrView
                })
              }
            }
          }
          // otherwise - this isn't a primary copy OR the repeat type isn't by proposed insured or guarantee issue
          else {
            //   let childSignerCounter = 0

            // loop through the template's signers
            for (let s = 0; s < templates[t].signers.length; s++) {
              // initialize the accounted for flag to false if we haven't initialized it
              if (templates[t].signers[s].accountedFor === undefined) {
                templates[t].signers[s].accountedFor = false
              }

              // determine the role index of the person type of this signer
              // within the template's applicable roles
              // to find the role type that the code understands

              let roleIdx = undefined
              //let childTemplateRoleName = undefined

              // a.roleType is roles' roleName
              roleIdx = applicableRoles.findIndex(
                a =>
                  a.roleType.toLowerCase() ===
                  templates[t].signers[s].person.type.toLowerCase()
              )

              let role = ''
              let signerIdx = body.signers.findIndex(
                sn => sn.id === templates[t].signers[s].person.id
              )

              if (signerIdx >= 0) {
                role = body.signers[signerIdx].role
              }

              // if the role index exists:
              if (roleIdx >= 0) {
                // logic switch based on employee/spouse/child:
                switch (templates[t].signers[s].person.type.toLowerCase()) {
                  case 'employee':
                    // the employee is always going to sign every page
                    // add him/her to the copy's signers:

                    copy.signers.push({
                      signer: templates[t].signers[s],
                      role: applicableRoles[roleIdx].templateRoleName,
                      mapRole: role,
                      signOrView: applicableRoles[roleIdx].signOrView
                    })

                    break

                  case 'spouse':
                    // Spouse only needs to sign the pages he/she is on this copy as a proposed insured

                    if (
                      this.determineSpouseSignature(
                        templates[t],
                        copy.copyNumber
                      )
                    ) {
                      copy.signers.push({
                        signer: templates[t].signers[s],
                        role: applicableRoles[roleIdx].templateRoleName,
                        mapRole: role,
                        signOrView: applicableRoles[roleIdx].signOrView
                      })
                    }

                    break
                  default:
                    // handle assigning children separately below as those assignments are more complex
                    break
                }
              }
            }
          }

          ///-------------------------------------------------------------------------------------------------------------------------------
          // Handle assigning the children signers:

          let pages = this.determineChildrenPerPage(templates[t], body)

          // console.log(pages);

          if (pages && pages.length > 0 && copy.copyNumber <= pages.length) {
            // find the template's signing roles for children
            let childRoles = applicableRoles.filter(
              a => a.roleType.toLowerCase() === 'child'
            )

            // console.log(childRoles);

            let roleCntr = 0

            for (let p = 0; p < pages[copy.copyNumber - 1].length; p++) {
              if (pages[copy.copyNumber - 1][p].role != '') {
                if (childRoles[roleCntr]) {
                  let idx = templates[t].signers.findIndex(
                    s =>
                      pages[copy.copyNumber - 1] &&
                      pages[copy.copyNumber - 1][p] &&
                      s.person.id === pages[copy.copyNumber - 1][p].applicant
                  )
                  if (idx >= 0) {
                    copy.signers.push({
                      signer: templates[t].signers[idx],
                      role: childRoles[roleCntr].templateRoleName,
                      mapRole: pages[copy.copyNumber - 1][p].role,
                      signOrView: childRoles[roleCntr].signOrView
                    })
                  }
                }
                roleCntr++
              }
            }
          }
          ///-------------------------------------------------------------------------------------------------------------------------------

          // add the copy to the primary templates related documents array
          // each copy will become a document in the final envelope

          templates[t].relatedDocuments.push(copy)
        }
      }

      // if we have documents to generate for this template, start building out the templates
      // section of the request body:
      if (
        templates[t].relatedDocuments &&
        templates[t].relatedDocuments.length > 0
      ) {
        // loop through the documents for this template
        for (let rd = 0; rd < templates[t].relatedDocuments.length; rd++) {
          // increase the overall document count to use as the template id in the api call
          apiTemplateId++

          let pages = this.determineChildrenPerPage(templates[t], body)

          let fieldsToOmit = []

          // build the initial document object for the body's templates array
          let template = {
            id: apiTemplateId,
            templateCopyNumber: templates[t].relatedDocuments[rd].copyNumber,
            documentName: templates[t].relatedDocuments[rd].documentName,
            snTemplateId: templates[t].relatedDocuments[rd].snTemplateId,
            dsTemplateId: templates[t].relatedDocuments[rd].dsTemplateId,
            signingRoles: templates[t].relatedDocuments[rd].signers.length,
            mapRoles: {},
            prefilled: {},
            texts: {},
            checks: {}
          }

          // populate the role mappings for each signer
          for (
            let s = 0;
            s < templates[t].relatedDocuments[rd].signers.length;
            s++
          ) {
            template.mapRoles[
              templates[t].relatedDocuments[rd].signers[s].role
            ] = templates[t].relatedDocuments[rd].signers[s].mapRole
          }

          // Build out the signers section of the body:

          // for each signer associated with this copy:
          for (
            let s = 0;
            s < templates[t].relatedDocuments[rd].signers.length;
            s++
          ) {
            // single out the signer
            let signer = templates[t].relatedDocuments[rd].signers[s]

            // look for the signer in the body signers array
            let idx = body.signers.findIndex(
              sign => sign.id === signer.signer.person.id
            )

            // if the signer exists in the body
            if (idx >= 0) {
              // add this templateId to documents array for the signer
              body.signers[idx].documents.push({
                templateId: apiTemplateId,
                signOrView: signer.signOrView
              })
            }
          }

          // find the static fields for prepopulation
          let texts = this.texts.filter(
            txt =>
              txt.templateId === templates[t].relatedDocuments[rd].templateId
          )

          // find the editable fields for prepopulation
          let prefills = this.prefilled.filter(
            p => p.templateId === templates[t].relatedDocuments[rd].templateId
          )

          // populate the data into the template copy from the collected website fields:

          // Texts: i.e. static fields:

          if (texts && texts.length > 0) {
            // for each static field:
            for (let txt = 0; txt < texts.length; txt++) {
              let value = ''
              let label = ''

              if (texts[txt].label && texts[txt].labelMapToField) {
                let label_idx = this.fields.findIndex(
                  f => f.id === texts[txt].labelMapToField
                )

                // if the field mapping was found:
                if (label_idx >= 0) {
                  // get the value to prefill the field with by calling getField
                  // with the appropriate fieldname and (when applicable) childInstance

                  let labelvalue = this.getField(
                    this.fields[label_idx].fieldName,
                    templates[t].applicants,
                    0,
                    texts[txt].planInstance,
                    templates[t].relatedDocuments[rd].copyNumber,
                    templates[t].rules.childCount,
                    templates[t].rules.planCount,
                    templates[t].rules.childSignatureCount,
                    pages,
                    texts[txt].labelFormatRule,
                    templates[t].cancerApplicant
                  )

                  if (
                    labelvalue != undefined &&
                    labelvalue != '' &&
                    texts[txt].labelFormatRule
                  ) {
                    label = texts[txt].label.replace(
                      ':1',
                      this.applyFormatRule(
                        texts[txt].labelFormatRule,
                        labelvalue
                      )
                    )
                  } else if (labelvalue != undefined && labelvalue != '') {
                    label = texts[txt].label.replace(':1', labelvalue)
                  }
                }
              }

              if (
                templates[t].isCancerTemplate &&
                texts[txt].excludeIfSoloApplicant == true &&
                templates[t].indCancerPlan == true
              ) {
                continue
              }

              // For cancer templates for individual applicants, look to altFields when present if individual applicant
              // is not the employee
              if (
                templates[t].isCancerTemplate &&
                texts[txt].altFields &&
                templates[t].indCancerPlan == true
              ) {
                let idx

                let mapToField = ''
                let childInstance = undefined

                if (
                  templates[t].cancerApplicant.person.type.toLowerCase() ==
                  'spouse'
                )
                  mapToField = texts[txt].altFields.spouse
                else if (
                  templates[t].cancerApplicant.person.type.toLowerCase() ==
                  'child'
                ) {
                  mapToField = texts[txt].altFields.child
                  childInstance = 1
                } else mapToField = texts[txt].mapToField

                idx = this.fields.findIndex(f => f.id === mapToField)

                if (idx >= 0) {
                  // call the getField function to get the value to prepopulate

                  value = this.getField(
                    this.fields[idx].fieldName, // the name of the field as the code knows it
                    templates[t].applicants, // the applicants ppol
                    childInstance, // the child instance for the field, 1 if sole applicant is a child
                    texts[txt].planInstance, // which plan to associate with this field (the 1st/2nd/3rd/etc plan selection - undefined for non-plan related fields)
                    templates[t].relatedDocuments[rd].copyNumber, // the copy number of this template copy (page number)
                    templates[t].rules.childCount, // the number of children allowed per page according to the template rules
                    templates[t].rules.planCount, // the number of plans allowed per page according to the template rules
                    templates[t].rules.childSignatureCount, // the number of child signatures allowed per page according to the template rules,
                    pages,
                    texts[txt].formatRule,
                    templates[t].cancerApplicant
                  )
                }
              }

              // if this static field has proposed insured mappings,
              // the mappings will vary from copy to copy:
              else if (texts[txt].piMappingIds) {
                // Each signer has one copy, assign the fieldname
                // based on this copy's signer.

                let signer = templates[t].relatedDocuments[rd].signers[0]

                //let signer = templates[t].signers[rd]

                if (signer.applicant) {
                  signer = signer.applicant
                }

                // copy.signers.push({
                //   // the signer him/herself
                //   signer: a.person,
                //   // the signer's role as it appears on the SignNow template
                //   role: applicableRoles[roleIdx].templateRoleName,
                //   // the signer's role as the code is aware of it -
                //   // the lambda service call will map template role to this role
                //   // during the course of prefilling the template's information
                //   mapRole: role,
                //   signOrView: applicableRoles[roleIdx].signOrView,
                //   applicant: a.person,
                // })

                // if we don't have a signer for this copy, omit the field
                if (!signer) continue

                let mapToField = ''
                let childInstance = undefined

                // if this signer is the employee, grab the employee field mapping
                if (signer.person.type === 'employee')
                  mapToField = texts[txt].piMappingIds.employee
                // else if this signer is the spouse, grab the spouse field mapping
                else if (signer.person.type === 'spouse')
                  mapToField = texts[txt].piMappingIds.spouse
                // otherwise if the signer is a child, grab the child field mapping
                else if (signer.person.type === 'child') {
                  mapToField = texts[txt].piMappingIds.child

                  // because there's potentially more than one child
                  // we need to assign a child instance to the mapping
                  // to make sure we pull the correct child's information later

                  let childCounter = 0

                  for (let a = 0; a < templates[t].applicants.length; a++) {
                    if (templates[t].applicants[a].person.type === 'child') {
                      // count all the children
                      childCounter++

                      // if this child is the signer, assign the child instance
                      // as the 'childCounter' numbered child and break out of the
                      // loop
                      if (
                        templates[t].applicants[a].person.id ===
                        signer.person.id
                      ) {
                        childInstance = childCounter
                        break
                      }
                    }
                  }
                }

                // find the index of the field mapping for this text field
                let idx = this.fields.findIndex(f => f.id === mapToField)

                if (idx >= 0) {
                  // call the getField function to get the value to prepopulate

                  value = this.getField(
                    this.fields[idx].fieldName, // the name of the field as the code knows it
                    templates[t].applicants, // the applicants ppol
                    childInstance, // the child instance for the field as calculated above (undefined for non-child related fields)
                    texts[txt].planInstance, // which plan to associate with this field (the 1st/2nd/3rd/etc plan selection - undefined for non-plan related fields)
                    templates[t].relatedDocuments[rd].copyNumber, // the copy number of this template copy (page number)
                    templates[t].rules.childCount, // the number of children allowed per page according to the template rules
                    templates[t].rules.planCount, // the number of plans allowed per page according to the template rules
                    templates[t].rules.childSignatureCount, // the number of child signatures allowed per page according to the template rules,
                    pages,
                    texts[txt].formatRule,
                    templates[t].cancerApplicant
                  )
                }
              } else {
                // this is not one of the proposed insured fields (normal scenario)
                // the mappings do not vary by document copy - look up the field mapping
                let idx = this.fields.findIndex(
                  f => f.id === texts[txt].mapToField
                )

                // if the mapping was found
                if (idx >= 0) {
                  // call the getField function to get the value to prepopulate

                  value = this.getField(
                    this.fields[idx].fieldName,
                    templates[t].applicants,
                    texts[txt].childInstance,
                    texts[txt].planInstance,
                    templates[t].relatedDocuments[rd].copyNumber,
                    templates[t].rules.childCount,
                    templates[t].rules.planCount,
                    templates[t].rules.childSignatureCount,
                    pages,
                    texts[txt].formatRule,
                    templates[t].cancerApplicant
                  )
                }
              }

              // if there's a date format instruction associated with the field
              // translate the date into the format requested and store the result back in value
              if (value && texts[txt].dateFormat != undefined) {
                let dateVal = Date.parse(value)
                let formattedDate = dateFormat(dateVal, texts[txt].dateFormat)
                value = formattedDate
              }

              if (value && texts[txt].formatRule) {
                value = this.applyFormatRule(texts[txt].formatRule, value)
              }

              if (value) {
                // if the field definition specifies
                // to concatenate the value with another website
                // value:
                if (texts[txt].mapConcatExp) {
                  // save the value to value1
                  let value1 = value

                  // find the concat field's mapping
                  let idx2 = this.fields.findIndex(
                    f => f.id === texts[txt].mapToField_2
                  )

                  // if found, get the concat field's value
                  if (idx2 >= 0) {
                    let value2 = this.getField(
                      this.fields[idx2].fieldName,
                      templates[t].applicants,
                      texts[txt].childInstance,
                      texts[txt].planInstance,
                      templates[t].relatedDocuments[rd].copyNumber,
                      templates[t].rules.childCount,
                      templates[t].rules.planCount,
                      templates[t].rules.childSignatureCount,
                      pages,
                      texts[txt].formatRule_2,
                      templates[t].cancerApplicant
                    )

                    if (value2 && texts[txt].formatRule_2) {
                      value2 = this.applyFormatRule(
                        texts[txt].formatRule_2,
                        value2
                      )
                    }

                    // do a replace on the concatenation expression, replacing ':1' with value 1
                    // and ':2' with value 2. Store the resulting string back in value.

                    if (value1 === '' && value2 === '') {
                      if (texts[txt].conditionalFields) {
                        for (
                          let i = 0;
                          i < texts[txt].conditionalFields.length;
                          i++
                        ) {
                          fieldsToOmit.push(texts[txt].conditionalFields[i])
                        }
                      }
                    }

                    if (
                      value1 != '' ||
                      value2 != '' ||
                      !texts[txt].omitIfMissing
                    ) {
                      template.texts[texts[txt].templateFieldName] = {
                        data: texts[txt].mapConcatExp
                          .replace(':1', value1)
                          .replace(':2', value2), // the data to pre-populate
                        size: texts[txt].size, // the font size pulled from the text field definition
                        font: texts[txt].font, // the font pulled from the text field definition
                        label: label
                      }
                    }
                  }
                } else {
                  // just save off the value

                  if (value === '') {
                    if (texts[txt].conditionalFields) {
                      for (
                        let i = 0;
                        i < texts[txt].conditionalFields.length;
                        i++
                      ) {
                        fieldsToOmit.push(texts[txt].conditionalFields[i])
                      }
                    }
                  }

                  if (value != '' || !texts[txt].omitIfMissing) {
                    template.texts[texts[txt].templateFieldName] = {
                      data: value, // the data to pre-populate
                      size: texts[txt].size, // the font size pulled from the text field definition
                      font: texts[txt].font, // the font pulled from the text field definition
                      label: label,
                      type: texts[txt].type
                    }
                  }
                }
              } else {
                if (texts[txt].conditionalFields) {
                  for (
                    let i = 0;
                    i < texts[txt].conditionalFields.length;
                    i++
                  ) {
                    fieldsToOmit.push(texts[txt].conditionalFields[i])
                  }
                }

                if (!texts[txt].omitIfMissing) {
                  template.texts[texts[txt].templateFieldName] = {
                    data: '',
                    size: texts[txt].size,
                    font: texts[txt].font,
                    label: label,
                    type: texts[txt].type
                  }
                }
              }
            }
          }

          // Prefills: i.e. editable fields:

          if (prefills && prefills.length > 0) {
            // loop through the prefill (editable) fields for this template
            for (let p = 0; p < prefills.length; p++) {
              let value = ''
              let label = ''

              if (prefills[p].label && prefills[p].labelMapToFieldId) {
                let label_idx = this.fields.findIndex(
                  f => f.id === prefills[p].labelMapToFieldId
                )

                // if the field mapping was found:
                if (label_idx >= 0) {
                  // get the value to prefill the field with by calling getField
                  // with the appropriate fieldname and (when applicable) childInstance

                  let labelvalue = this.getField(
                    this.fields[label_idx].fieldName,
                    templates[t].applicants,
                    0,
                    prefills[p].planInstance,
                    templates[t].relatedDocuments[rd].copyNumber,
                    templates[t].rules.childCount,
                    templates[t].rules.planCount,
                    templates[t].rules.childSignatureCount,
                    pages,
                    prefills[p].labelFormatRule,
                    templates[t].cancerApplicant
                  )

                  if (
                    labelvalue != undefined &&
                    labelvalue != '' &&
                    prefills[p].labelFormatRule
                  ) {
                    label = prefills[p].label.replace(
                      ':1',
                      this.applyFormatRule(
                        prefills[p].labelFormatRule,
                        labelvalue
                      )
                    )
                  } else if (labelvalue != undefined && labelvalue != '') {
                    label = prefills[p].label.replace(':1', labelvalue)
                  }
                }
              }

              // if this static field has proposed insured mappings,
              // the mappings will vary from copy to copy:
              if (prefills[p].piMappingIds) {
                // Each signer has one copy, assign the fieldname
                // based on this copy's signer.

                let signer = templates[t].relatedDocuments[rd].signers[0]
                // let signer = templates[t].signers[rd] // rd is the related document's index

                if (signer.applicant) {
                  signer = signer.applicant
                }

                // if there's not an associate signer, omit the field
                if (!signer) continue

                let mapToField = ''
                let childInstance = undefined

                // Determine the signer's person type and grab the appropriate field mapping ID
                if (signer.person.type === 'employee')
                  mapToField = prefills[p].piMappingIds.employee
                else if (signer.person.type === 'spouse')
                  mapToField = prefills[p].piMappingIds.spouse
                else if (signer.person.type === 'child') {
                  mapToField = prefills[p].piMappingIds.child

                  // For children, assign a childInstance based on where this child signer
                  // falls in line with all the child applicants for use in the getField
                  // function later:
                  let childCounter = 0

                  for (let a = 0; a < templates[t].applicants.length; a++) {
                    if (templates[t].applicants[a].person.type === 'child') {
                      // count each child
                      childCounter++

                      // if this child is the signer, set the childInstance
                      // and break out of the loop
                      if (
                        templates[t].applicants[a].person.id ===
                        signer.person.id
                      ) {
                        childInstance = childCounter
                        break
                      }
                    }
                  }
                }

                // find the field mapping of the map-to field
                let idx = this.fields.findIndex(f => f.id === mapToField)

                // if the field mapping was found:
                if (idx >= 0) {
                  // get the value to prefill the field with by calling getField
                  // with the appropriate fieldname and (when applicable) childInstance

                  value = this.getField(
                    this.fields[idx].fieldName,
                    templates[t].applicants,
                    childInstance,
                    prefills[p].planInstance,
                    templates[t].relatedDocuments[rd].copyNumber,
                    templates[t].rules.childCount,
                    templates[t].rules.planCount,
                    templates[t].rules.childSignatureCount,
                    pages,
                    prefills[p].formatRule,
                    templates[t].cancerApplicant
                  )
                }
              }

              // else this is the normal field mapping scenario - the mapping
              // doesn't change regardless of which document copy we're on
              else {
                // find the field mapping
                let idx = this.fields.findIndex(
                  f => f.id === prefills[p].mapToFieldId
                )

                // if mapping found
                if (idx >= 0) {
                  // get the value of the appropriate field from the website data
                  // by calling getField

                  value = this.getField(
                    this.fields[idx].fieldName,
                    templates[t].applicants,
                    prefills[p].childInstance,
                    prefills[p].planInstance,
                    templates[t].relatedDocuments[rd].copyNumber,
                    templates[t].rules.childCount,
                    templates[t].rules.planCount,
                    templates[t].rules.childSignatureCount,
                    pages,
                    prefills[p].formatRule,
                    templates[t].cancerApplicant
                  )
                }
              }

              // if we retrieved a value and there's a date format request
              // on the field definition, return the date in the requested format:
              if (value && prefills[p].dateFormat != undefined) {
                let dateVal = Date.parse(value)
                let formattedDate = dateFormat(dateVal, prefills[p].dateFormat)
                value = formattedDate
              }

              if (value && prefills[p].formatRule) {
                value = this.applyFormatRule(prefills[p].formatRule, value)
              }

              // if we retrieved a value
              if (value) {
                // save the value to value1
                let value1 = value

                // if the field definition specifies
                // to concatenate the value with another website
                // value:
                if (prefills[p].mapConcatExp) {
                  // find the concat field's mapping
                  let idx2 = this.fields.findIndex(
                    f => f.id === prefills[p].mapToFieldId_2
                  )

                  // if found, get the concat field's value
                  if (idx2 >= 0) {
                    let value2 = this.getField(
                      this.fields[idx2].fieldName,
                      templates[t].applicants,
                      prefills[p].childInstance,
                      prefills[p].planInstance,
                      templates[t].relatedDocuments[rd].copyNumber,
                      templates[t].rules.childCount,
                      templates[t].rules.planCount,
                      templates[t].rules.childSignatureCount,
                      pages,
                      undefined,
                      templates[t].cancerApplicant
                    )

                    if (value2 && prefills[p].formatRule_2) {
                      value2 = this.applyFormatRule(
                        prefills[p].formatRule_2,
                        value2
                      )
                    }

                    // add the concat expression to the prefilled
                    // array, replacing the placeholders :1 and :2
                    // with value1 and value2, respectively

                    if (value1 === '' && value2 === '') {
                      if (prefills[p].conditionalFields) {
                        for (
                          let i = 0;
                          i < prefills[p].conditionalFields.length;
                          i++
                        ) {
                          fieldsToOmit.push(prefills[p].conditionalFields[i])
                        }
                      }
                    }

                    if (
                      value1 != '' ||
                      value2 != '' ||
                      !prefills[p].omitIfMissing
                    ) {
                      template.prefilled[prefills[p].templateFieldName] = {
                        data: prefills[p].mapConcatExp
                          .replace(':1', value1)
                          .replace(':2', value2),
                        label: label,
                        type: prefills[p].type
                      }
                    }
                  }
                } else {
                  // no concatenation necessary, simply save off the value
                  // to the prefilled values array

                  if (value === '') {
                    if (prefills[p].conditionalFields) {
                      for (
                        let i = 0;
                        i < prefills[p].conditionalFields.length;
                        i++
                      ) {
                        fieldsToOmit.push(prefills[p].conditionalFields[i])
                      }
                    }
                  }

                  if (value != '' || !prefills[p].omitIfMissing) {
                    template.prefilled[prefills[p].templateFieldName] = {
                      data: value,
                      label: label,
                      type: prefills[p].type
                    }
                  }
                }
              } else {
                if (prefills[p].conditionalFields) {
                  for (
                    let i = 0;
                    i < prefills[p].conditionalFields.length;
                    i++
                  ) {
                    fieldsToOmit.push(prefills[p].conditionalFields[i])
                  }
                }

                if (!prefills[p].omitIfMissing) {
                  template.prefilled[prefills[p].templateFieldName] = {
                    data: '',
                    label: label,
                    type: prefills[p].type
                  }
                }
              }
            }
          }

          for (let i = 0; i < fieldsToOmit.length; i++) {
            let found = false

            if (template.prefilled[fieldsToOmit[i]]) {
              template.prefilled[fieldsToOmit[i]] = {
                data: '',
                label: undefined
              }
              found = true
            }

            if (template.texts[fieldsToOmit[i]]) {
              template.texts[fieldsToOmit[i]].data = ''
              found = true
            }

            if (!found) {
              template.prefilled[fieldsToOmit[i]] = {
                data: '',
                label: undefined
              }
            }
          }

          // Add the template with the texts/prefils/etc to the body's templates array
          body.templates.push(template)
        }
      }
    }

    // Add Leave Behinds In
    for (let template of body.templates) {
      let templateDef = this.definitions.find(
        d => d.dsTemplateId == template.dsTemplateId
      )

      if (templateDef) {
        for (let leaveBehind of this.leaveBehinds) {
          if (leaveBehind.includeWithTemplateIds.indexOf(templateDef.id) >= 0) {
            let foundIt = body.templates.findIndex(
              t => t.dsTemplateId == leaveBehind.dsTemplateId
            )
            if (foundIt < 0) {
              body.templates.push({
                id: body.templates.length + 1,
                templateCopyNumber: 1,
                documentName: 'Leave Behind',
                snTemplateId: 'na',
                dsTemplateId: leaveBehind.dsTemplateId,
                signingRoles: 1,
                mapRoles: {
                  'Role 1': 'Employee'
                },
                prefilled: {},
                texts: {},
                checks: {}
              })
            }
          }
        }
      }
    }

    return body
  },
  determineSpouseSignature(template, copyNumber) {
    let repeatByPlan = false

    if (template.repeatTypes.findIndex(r => r === 'plan') >= 0)
      repeatByPlan = true

    let spouseIdx = template.applicants.findIndex(
      a => a.person.type === 'spouse'
    )

    if (spouseIdx >= 0) {
      let sumIdx = store.state.summaryRows.findIndex(
        s => s.id === template.applicants[spouseIdx].person.id
      )

      let signer = false

      if (sumIdx >= 0) {
        if (store.state.summaryRows[sumIdx].sigReq === 'Required') signer = true
      }

      if (!signer) return false

      if (!repeatByPlan) {
        if (copyNumber === 1) return true
        else return false
      } else {
        let numPlans = template.applicants[spouseIdx].plans.length

        if (copyNumber <= numPlans) {
          return true
        } else return false
      }
    }
  },
  determineChildrenPerPage(template, body) {
    let childAndPlan = []
    let repeatByPlan = false

    if (template.repeatTypes.findIndex(r => r === 'gi') >= 0) return []

    if (template.repeatTypes.findIndex(r => r === 'gi_separate') >= 0) return []

    if (template.repeatTypes.findIndex(r => r === 'plan') >= 0)
      repeatByPlan = true

    for (let a = 0; a < template.applicants.length; a++) {
      if (template.applicants[a].person.type === 'child') {
        for (let p = 0; p < template.applicants[a].plans.length; p++) {
          if (!repeatByPlan && p > 0) continue

          let sumIdx = store.state.summaryRows.findIndex(
            s => s.id === template.applicants[a].person.id
          )

          let signer = false

          if (sumIdx >= 0) {
            if (store.state.summaryRows[sumIdx].sigReq === 'Required')
              signer = true
          }

          let roleIdx = body.signers.findIndex(
            s => s.id === template.applicants[a].person.id
          )
          let role = ''

          if (roleIdx >= 0) role = body.signers[roleIdx].role

          let ChildWithPlan = {
            applicant: template.applicants[a].person.id,
            role: role,
            plan: template.applicants[a].plans[p],
            isSigner: signer,
            accountedFor: false
          }

          childAndPlan.push(ChildWithPlan)
        }
      }
    }

    let pages = []

    let totalEntries = childAndPlan.length

    let pageIdx = -1

    while (totalEntries > 0) {
      pageIdx += 1
      pages[pageIdx] = []

      let childSigsThisPage = template.rules.childSignatureCount
        ? template.rules.childSignatureCount
        : 1
      let childrenThisPage = template.rules.childCount
        ? template.rules.childCount
        : 20

      for (let child = 0; child < childAndPlan.length; child++) {
        if (!childAndPlan[child].accountedFor) {
          if (childrenThisPage > 0) {
            let foundIdx = pages[pageIdx].findIndex(
              p => p.applicant === childAndPlan[child].applicant
            )

            // Don't put multiple plans for the same child on the same page
            if (foundIdx < 0) {
              if (childAndPlan[child].isSigner) {
                if (childSigsThisPage > 0) {
                  pages[pageIdx].push(childAndPlan[child])
                  childSigsThisPage--
                  childrenThisPage--
                  childAndPlan[child].accountedFor = true
                  totalEntries--
                } else {
                  continue
                }
              } else {
                pages[pageIdx].push(childAndPlan[child])
                childAndPlan[child].accountedFor = true
                childrenThisPage--
                totalEntries--
              }
            }
          }
        }
      }
    }

    return pages
  }
}
